"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
exports.__esModule = true;
var base_1 = require("./base");
/**
 * Gateway API Wrapper
 */
var GatewayClient = /** @class */ (function (_super) {
    __extends(GatewayClient, _super);
    function GatewayClient(debug, gatewayConfig, interceptor) {
        if (debug === void 0) { debug = true; }
        var _this = this;
        var defaultReqInterceptor = function (req) {
            if (interceptor && interceptor.request) {
                return interceptor.request(req);
            }
            return req;
        };
        var defaultRespInterceptor = function (resp) {
            var payload = {};
            // 过滤掉一层data
            if (resp.data.retCode === _this.successCode) {
                resp.data.data ? (payload = resp.data.data) : (payload = {});
                resp.data = payload;
            }
            if (interceptor && interceptor.response) {
                return interceptor.response(resp);
            }
            return resp;
        };
        _this = _super.call(this, debug, defaultReqInterceptor, defaultRespInterceptor) || this;
        _this.gatewayUrl = gatewayConfig.gatewayUrl;
        _this.edition = gatewayConfig.edition;
        _this.goods = gatewayConfig.goods;
        _this.terrace = gatewayConfig.terrace;
        _this.xbedSecretKey = gatewayConfig.xbedSecretKey;
        _this.xbedSecretToken = gatewayConfig.xbedSecretToken;
        return _this;
    }
    /**
     * login 登录接口
     */
    GatewayClient.prototype.login = function (username, password) {
        var url = this.gatewayUrl + "api/oms/login";
        var pwd = this.secret.md5(password);
        return this.preparePostRequest(url, {
            userName: username,
            passWord: pwd
        });
    };
    /**
     * logout 登出接口
     */
    GatewayClient.prototype.logout = function (token) {
        var url = this.gatewayUrl + "api/oms/logout";
        return this.prepareRequest(url, {}, 'post');
    };
    /**
     * 检查用户权限接口
     * @param requestPower 需要请求的地址
     * @param token
     */
    GatewayClient.prototype.checkUserPower = function (requestPower, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/userPower/check", { requestPower: requestPower }, token);
    };
    /**
     * 更新密码
     */
    GatewayClient.prototype.updatePassword = function (token, newPassWord, orgPassWord, username) {
        var url = this.gatewayUrl + "api/oms/changePassword";
        // 原始密码
        var orgPwd = this.secret.md5(orgPassWord);
        // 新密码
        var newPwd = this.secret.md5(newPassWord);
        return this.prepareRequest(url, {
            newPassWord: newPwd,
            orgPassWord: orgPwd,
            userName: username
        }, 'post', token);
    };
    /**
     * 发送验证码
     */
    GatewayClient.prototype.sendCaptcha = function (phone, type) {
        if (type === void 0) { type = 'text'; }
        var CaptchatType;
        (function (CaptchatType) {
            CaptchatType[CaptchatType["text"] = 1] = "text";
            CaptchatType[CaptchatType["voice"] = 0] = "voice";
        })(CaptchatType || (CaptchatType = {}));
        var params = {
            isText: CaptchatType[type],
            phone: phone
        };
        var url = this.gatewayUrl + "api/owner/getVerificationCode";
        return this.prepareRequest(url, params, 'post');
    };
    /**
     * 查询省份列表
     */
    GatewayClient.prototype.queryProvinceList = function () {
        return this.prepareRequest(this.gatewayUrl + "api/ljh/queryProvinceList", {}, 'post');
    };
    /**
     * 查询城市列表
     * @param provinceName 省份中文名 e.g. 广东省
     */
    GatewayClient.prototype.queryCityList = function (provinceName) {
        return this.prepareRequest(this.gatewayUrl + "api/ljh/queryCityList", { provinceName: provinceName }, 'post');
    };
    /**
     * 查询区域列表
     * @param provinceName 省份中文名 e.g. 广东省
     * @param cityName 城市中文名 e.g. 广州市
     */
    GatewayClient.prototype.queryCountyList = function (provinceName, cityName) {
        return this.prepareRequest(this.gatewayUrl + "api/ljh/queryCountyList", { provinceName: provinceName, cityName: cityName }, 'post');
    };
    /**
     * 分页查询文章列表
     * @param column 文章栏目(1 => 集团动态，2 => 媒体报道，3 => 培训资料,null => 当前终端全部)
     * @param page
     * @param pageSize
     * @param terminal 终端位置(1Xbed官网，2丽家会，3其他，null 全部终端)
     * @param token
     */
    GatewayClient.prototype.queryArticleList = function (params, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/appbase/article/list", params, 'post', token);
    };
    /**
     * 文章列表页下拉列表
     * @param type 文章类型
     * @param token
     */
    GatewayClient.prototype.getArticleSelective = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/appbase/article/getSelective", params, token);
    };
    /**
     * 删除文章
     * @param articleId 文章id
     * @param updateName 操作人
     */
    GatewayClient.prototype.deleteArticle = function (articleId, updateName, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/appbase/article/delete", { articleId: articleId, updateName: updateName }, 'post', token);
    };
    /**
     * 添加文章
     * @param SEOtags SEO标签(逗号分割)
     * @param column 文章栏目(1集团动态，2媒体报道)
     * @param content	文章内容
     * @param coverPicPath 封面图片地址
     * @param createName 创建人
     * @param reprintUrl 转载链接
     * @param source 文章来源(1原创，2转载)
     * @param status 状态(0隐藏，1显示)
     * @param summary 文章摘要
     * @param terminal 终端位置(1Xbed官网，2IOS,3安卓，4微信)
     * @param title 文章标题
     * @param sortNum 优先级
     * @param city 文章所配置的城市，其他栏目不传
     * @param cityId 城市Id,与城市名顺序保持一致
     * @param type 类型（1新闻动态 2旅游攻略 3丽家会培训 4 其他）
     * @param token
     */
    GatewayClient.prototype.addArticle = function (params, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/appbase/article/add", params, 'post', token);
    };
    /**
     * 编辑文章
     * @param SEOtags SEO标签(逗号分割)
     * @param articleId 文章ID
     * @param column 文章栏目(1集团动态，2媒体报道)
     * @param content	文章内容
     * @param coverPicPath 封面图片地址
     * @param updateName 更新人
     * @param reprintUrl 转载链接
     * @param source 文章来源(1原创，2转载)
     * @param status 状态(0隐藏，1显示)
     * @param summary 文章摘要
     * @param terminal 终端位置(1Xbed官网，2IOS,3安卓，4微信)
     * @param title 文章标题
     * @param sortNum 优先级
     * @param type 类型（1新闻动态 2旅游攻略 3丽家会培训 4 其他）
     * @param city 文章所配置的城市，其他栏目不传
     * @param cityId 城市Id,与城市名顺序保持一致
     * @param token
     */
    GatewayClient.prototype.editArticle = function (params, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/appbase/article/edit", params, 'post', token);
    };
    /**
     * 编辑文章置顶
     * @deprecated
     * @param articleId 文章ID
     * @param top 是否置顶
     * @param updateName 修改人
     * @param token
     */
    GatewayClient.prototype.topArticle = function (articleId, top, updateName, token) {
        var isTop = top ? 1 : 0;
        return this.prepareRequest(this.gatewayUrl + "/api/oms/appbase/article/editIsTop", { articleId: articleId, isTop: isTop, updateName: updateName }, 'post', token);
    };
    /**
     * 文章详情
     * @param articleId 文章id
     */
    GatewayClient.prototype.articleDetails = function (articleId) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/appbase/article/articleDetails", { articleId: articleId }, 'post');
    };
    /**
     * 查找所有广告（蓝主人用）
     * @param terminal 终端 4 = 蓝主人
     */
    GatewayClient.prototype.findAllAdvert = function (terminal) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/appbase/advert/findAllAdvert", { terminal: terminal }, 'post');
    };
    /**
     * 分页查询广告列表
     * @param page
     * @param pageSize
     * @param type 广告类型(1轮播图，2广告图，3招聘图，4热门城市图，5新闻动态，6精品设计)
     * @param terminal 终端(0所有，1微信，2IOS，3Android，4微信蓝主人，5Xbed官网，6丽家会)
     */
    GatewayClient.prototype.queryAdvertList = function (page, pageSize, type, name, terminal, token) {
        var reqData = { page: page, pageSize: pageSize, type: type, name: name };
        if (terminal || terminal === 0) {
            reqData.terminal = terminal;
        }
        return this.prepareRequest(this.gatewayUrl + "api/oms/appbase/advert/list", reqData, 'post', token);
    };
    /**
     * 删除广告
     */
    GatewayClient.prototype.deleteAdvert = function (advertId, updateName, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/appbase/advert/delete", { advertId: advertId, updateName: updateName }, 'post', token);
    };
    /**
     * 添加广告
     * @param createName 创建人
     * @param materialId 素材ID
     * @param name
     * @param picPath 图片地址
     * @param remark
     * @param status 状态(0关闭，1开启)
     * @param terminal 终端(0所有，1微信，2IOS，3Android，4微信蓝主人，5Xbed官网)
     * @param type 广告类型(1轮播图，2广告图，3招聘图，4热门城市图，5新闻动态，6精品设计
     * @param url 	外部链接地址
     * @param sortNum 排序值
     * @param token
     */
    GatewayClient.prototype.addAdvert = function (params, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/appbase/advert/add", params, 'post', token);
    };
    /**
     * 编辑广告
     * @param advertId 广告ID
     * @param materialId 素材ID
     * @param name
     * @param picPath 图片地址
     * @param remark
     * @param status 状态(0关闭，1开启)
     * @param terminal 终端(0所有，1微信，2IOS，3Android，4微信蓝主人，5Xbed官网)
     * @param type 广告类型(1轮播图，2广告图，3招聘图，4热门城市图，5新闻动态，6精品设计
     * @param updateName
     * @param url 	外部链接地址
     * @param token
     */
    GatewayClient.prototype.editAdvert = function (params, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/appbase/advert/edit", params, 'post', token);
    };
    /**
     * 查询销售中状态的房间List
     * @param key 房间ID/名
     * @param token
     */
    GatewayClient.prototype.queryHomeList = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/rooms/info/inSalesRoomList", params, token);
    };
    /**
     * XBED渠道中上线门店List
     * @param key 门店id/名
     * @param token
     */
    GatewayClient.prototype.queryStoreList = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/chain/info/xbedChannelChainList", params, token);
    };
    /**
     * 置顶广告
     * @param advertId 广告ID
     * @param top 是否置顶
     * @param updateName 修改人
     * @param token
     */
    GatewayClient.prototype.topAdvert = function (advertId, top, updateName, token) {
        var isTop = top ? 1 : 0;
        return this.prepareRequest(this.gatewayUrl + "api/oms/appbase/advert/editIsTop", { advertId: advertId, isTop: isTop, updateName: updateName }, 'post', token);
    };
    /**
     * 热门城市列表
     * @param page
     * @param pageSize
     */
    GatewayClient.prototype.queryHotCityList = function (page, pageSize, cityName, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/appbase/hotCity/list", { page: page, pageSize: pageSize, cityName: cityName }, 'post', token);
    };
    /**
     * 查询不存在热门城市表的城市列表
     * @param token
     */
    GatewayClient.prototype.queryNotExistHotCity = function (token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/appbase/hotCity/selectNotExistCity", {}, 'post', token);
    };
    /**
     * 新增热门城市
     * @param cityName
     * @param cityPicUrl 城市图片URL
     * @param sortNum 排序值
     * @param status 状态(0关闭，1开启)
     * @param terminal 终端位置(0所有，1微信，2IOS，3Android)
     * @param createName 创建人
     */
    GatewayClient.prototype.addHotCity = function (cityName, cityPicUrl, sortNum, status, terminal, createName, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/appbase/hotCity/add", { cityName: cityName, cityPicUrl: cityPicUrl, sortNum: sortNum, status: status, terminal: terminal, createName: createName }, 'post', token);
    };
    /**
     * 编辑热门城市
     * @param id
     * @param cityName
     * @param cityPicUrl 城市图片URL
     * @param sortNum 排序值
     * @param status 状态(0关闭，1开启)
     * @param terminal 终端位置(0所有，1微信，2IOS，3Android)
     * @param updateName 修改人
     */
    GatewayClient.prototype.editHotCity = function (id, cityName, cityPicUrl, sortNum, status, terminal, updateName, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/appbase/hotCity/edit", { id: id, cityName: cityName, cityPicUrl: cityPicUrl, sortNum: sortNum, status: status, terminal: terminal, updateName: updateName }, 'post', token);
    };
    /**
     * 删除热门城市
     * @param id
     * @param updateName
     * @param token
     */
    GatewayClient.prototype.delHotCity = function (id, updateName, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/appbase/hotCity/delete", { id: id, updateName: updateName }, 'post', token);
    };
    /**
     * 丽家会加盟
     * @param province 省份
     * @param city 城市
     * @param district 区域
     * @param address 地址
     * @param ltype 	业务类型，现在有LJHJM
     * @param mobile 手机号码
     * @param name 姓名
     * @param cardId 身份证
     * @param remark 备注
     * @param sex	性别 0男 5女
     * @param source 了解渠道，0家人/朋友 5线下宣传/活动 10网络 15其他
     */
    GatewayClient.prototype.joinIn = function (province, city, district, address, ltype, mobile, name, cardId, remark, sex, source) {
        return this.prepareRequest(this.gatewayUrl + "api/ljh/joinIn", {
            province: province,
            city: city,
            district: district,
            address: address,
            ltype: ltype,
            mobile: mobile,
            name: name,
            cardId: cardId,
            remark: remark,
            sex: sex,
            source: source
        }, 'post');
    };
    /**
     * 业主加盟/星创俱乐部加盟
     * @param province 省份
     * @param city 城市
     * @param district 区域
     * @param address 地址
     * @param ltype 	业务类型，星创俱乐部：XCJLB 业主加盟：JOBLU
     * @param mobile 手机号码
     * @param name 姓名
     * @param remark 备注
     * @param sex	性别 0男 5女
     * @param source 了解渠道，0家人/朋友 5线下宣传/活动 10网络 15其他
     */
    GatewayClient.prototype.lender = function (province, city, district, address, ltype, mobile, name, remark, sex, source) {
        return this.prepareRequest(this.gatewayUrl + "api/owner/lender\n      ", {
            province: province,
            city: city,
            district: district,
            address: address,
            ltype: ltype,
            mobile: mobile,
            name: name,
            remark: remark,
            sex: sex,
            source: source
        }, 'post');
    };
    /**
     * 修改培训内容
     * @param contentUrl 培训内容url
     * @param coverUrl 封面图url
     * @param displayState 显示状态
     * @param id
     * @param trainingItem 	培训主题
     * @param trainingModule 培训模块
     * @param trainingName 培训内容名称
     */
    GatewayClient.prototype.editTrainContent = function (params, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/xbclean/xbCleanTraining/edit", params, 'post', token);
    };
    /**
     * 删除培训
     * @param id
     * @param token
     */
    GatewayClient.prototype.deleteTrainContent = function (id, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/xbclean/xbCleanTraining/delete\n      ", {
            id: id
        }, 'post', token);
    };
    /**
     * 培训内容列表
     * @param token
     */
    GatewayClient.prototype.trainContentList = function (page, rows, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/xbclean/xbCleanTraining/list\n      ", { page: page, rows: rows }, 'post', token);
    };
    /**
     * 新增培训内容
     * @param contentUrl 网址链接
     * @param coverUrl 封面图url
     * @param displayState 显示状态
     * @param trainingItem 培训主题
     * @param trainingModule 培训模块
     * @param trainingName 培训内容名称
     * @param token
     */
    GatewayClient.prototype.addTrainContent = function (params, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/xbclean/xbCleanTraining/add\n      ", params, 'post', token);
    };
    /**
     * 删除推荐房间
     * @param id
     * @param updateName 修改人
     * @param token
     */
    GatewayClient.prototype.deleteRecommendRoom = function (id, updateName, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/appbase/recommendRoom/delete\n      ", {
            id: id,
            updateName: updateName
        }, 'post', token);
    };
    /**
     * 推荐房间列表
     * @param page 页码
     * @param pageSize 每页大小
     * @param type 类型(2精选,3小住,4长留,5发现)
     * @param token
     */
    GatewayClient.prototype.recommendRoomList = function (page, pageSize, type, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/appbase/recommendRoom/list\n      ", {
            page: page,
            pageSize: pageSize,
            type: type
        }, 'post', token);
    };
    /**
     * 新增推荐房间
     * @param createName 创建人
     * @param roomId Xbed房间ID
     * @param roomName Xbed房间名称
     * @param roomNo Xbed房间编号
     * @param status 状态(0关闭，1开启)
     * @param type 类型(2精选,3小住,4长留,5发现)
     * @param token
     */
    GatewayClient.prototype.addRecommendRoom = function (createName, roomId, roomName, roomNo, status, type, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/appbase/recommendRoom/add\n      ", {
            createName: createName,
            roomId: roomId,
            roomName: roomName,
            roomNo: roomNo,
            status: status,
            type: type
        }, 'post', token);
    };
    /**
     * 编辑推荐房间
     * @param id
     * @param roomId Xbed房间ID
     * @param roomName Xbed房间名称
     * @param roomNo Xbed房间编号
     * @param status 状态(0关闭，1开启)
     * @param type 类型(2精选,3小住,4长留,5发现)
     * @param updateName
     * @param token 修改人
     */
    GatewayClient.prototype.editRecommendRoom = function (id, roomId, roomName, roomNo, status, type, updateName, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/appbase/recommendRoom/edit\n      ", {
            id: id,
            roomId: roomId,
            roomName: roomName,
            roomNo: roomNo,
            status: status,
            type: type,
            updateName: updateName
        }, 'post', token);
    };
    /**
     * 查询还未推荐的房间列表
     * @param page
     * @param pageSize
     * @param type 类型(2精选,3小住,4长留,5发现)
     */
    GatewayClient.prototype.queryNotExistRecommendRooms = function (page, pageSize, type, chainName, roomName, roomNo, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/appbase/recommendRoom/selectNotExistRoomList", { page: page, pageSize: pageSize, type: type, chainName: chainName, roomName: roomName, roomNo: roomNo }, 'post', token);
    };
    /**
     * 视频列表
     * @param page
     * @param pageSize
     * @param token
     */
    GatewayClient.prototype.videoList = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/video/videoList", params, token);
    };
    /**
     * 视频添加/修改
     * @param videoId
     * @param displayTerminalId 显示终端： 1 pc预定端，2其它
     * @param framePictureUrl 视频某一帧图url
     * @param sort 排序
     * @param status 状态 1 开启 0 关闭
     * @param user 操作人
     * @param videoCoverUrl 视频封面url
     * @param videoLength 视频时长
     * @param videoTitle 视频标题
     * @param videoUrl 视频链接
     * @param token
     */
    GatewayClient.prototype.updateVideo = function (params, token) {
        var reqUrl = params.videoId
            ? this.gatewayUrl + "api/video/videoEdit"
            : this.gatewayUrl + "api/video/videoAdd";
        return this.preparePostRequest(reqUrl, params, token);
    };
    /**
     * 视频删除
     * @param user 操作人
     * @param videoId 视频id
     * @param token
     */
    GatewayClient.prototype.deleteVideo = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/video/videoDelete", params, token);
    };
    /**
     * 显示终端列表
     * @param type 类型： video(视频)
     * @param token
     */
    GatewayClient.prototype.videoTerminal = function (type, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/displayTerminal/list", { type: type }, token);
    };
    //////////////////////////  打包房型 Start  //////////////////////////
    /**
     * 打包房型门店列表
     * @param channelId 渠道Id (必传)
     * @param city 城市
     * @param page
     * @param rows 每页数量
     * @param xbedHotelId 门店ID
     * @param xbedHotelName 门店名称
     * @param token
     */
    GatewayClient.prototype.getChannelHotelList = function (channelId, city, page, rows, xbedHotelId, xbedHotelName, token) {
        var reqData = {
            channelId: channelId,
            city: city,
            page: page,
            rows: rows
        };
        if (xbedHotelId) {
            reqData.xbedHotelId = xbedHotelId;
        }
        if (xbedHotelName) {
            reqData.xbedHotelName = xbedHotelName;
        }
        return this.preparePostRequest(this.gatewayUrl + "api/oms/ota/xbedChannelHotel/getChannelHotelList", reqData, token);
    };
    /**
     * 查询打包房型的省份列表
     * @param channelId 渠道Id
     */
    GatewayClient.prototype.queryXbedHotelProvinces = function (channelId, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/ota/xbedChannelHotel/getChannelHotelProvinces", {
            channelId: channelId
        }, token);
    };
    /**
     * 查询打包房型的城市列表
     * @param channelId 渠道id
     * @param province 省份
     */
    GatewayClient.prototype.queryXbedHotelCities = function (channelId, province, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/ota/xbedChannelHotel/getChannelHotelCities", {
            channelId: channelId,
            province: province
        }, token);
    };
    /**
     * 查询渠道门店详情基本信息
     * @param channelHotelId 门店Id （必传）
     * @param name 房型名称
     * @param status 状态（S01 上线 S02 下线）
     */
    GatewayClient.prototype.channelHotelDetail = function (channelHotelId, name, status, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/ota/xbedChannelHotel/channelHotelDetail", {
            channelHotelId: channelHotelId,
            name: name,
            status: status
        }, token);
    };
    /**
     * 查询全部房型列表
     * @param channelId 渠道id
     * @param status 打包状态 状态 S01:有效,S02:失效,S03:删除
     * @param hotelName 门店名称
     * @param name 房型名称
     * @param page 页
     * @param rows 行数
     * @param token
     */
    GatewayClient.prototype.queryAllRoomTypeList = function (channelId, status, hotelName, name, page, rows, token) {
        var reqData = { channelId: channelId, page: page, rows: rows };
        if (hotelName) {
            reqData.hotelName = hotelName;
        }
        if (name) {
            reqData.name = name;
        }
        if (status) {
            reqData.status = status;
        }
        return this.preparePostRequest(this.gatewayUrl + "api/oms/ota/xbedChannelRoomType/getRoomTypeList", reqData, token);
    };
    /**
     * 查询单个门店的房型列表
     * @param channelHotelId 门店Id
     * @param name 房型名称
     * @param page 页码
     * @param rows 每页数量
     * @param status 状态（S01 上线 S02 下线）
     * @param token
     */
    GatewayClient.prototype.getRoomTypeList = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/ota/xbedChannelHotel/getRoomTypeList", params, token);
    };
    /**
     * 查询未与Xbed绑定的酒店列表
     * @param channelId 渠道Id
     * @param city 城市
     * @param province 省份
     */
    GatewayClient.prototype.queryXbedHotelWithUnbind = function (channelId, city, province, token) {
        return this.preparePostRequest(this
            .gatewayUrl + "api/oms/ota/xbedChannelHotel/getChannelHotelByNotDocking", { channelId: channelId, city: city, province: province }, token);
    };
    /**
     * 新增门店
     * @param xbedHotelId 门店Id
     * @param operatorName 操作人
     */
    GatewayClient.prototype.addChannelHotel = function (xbedHotelId, operatorName, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/ota/xbedChannelHotel/addChannelHotel", { xbedHotelId: xbedHotelId, operatorName: operatorName }, token);
    };
    /**
     * 删除门店
     * @param xbedHotelId 门店Id
     * @param token
     */
    GatewayClient.prototype.deleteXbedHotel = function (xbedHotelId, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/ota/xbedChannelHotel/deleteChannelHotel", { xbedHotelId: xbedHotelId }, token);
    };
    /**
     * 编辑门店
     * @param channelHotelId 	门店Id（必传）
     * @param coverImage 	封面图
     * @param status 状态 S01上线 S02下线
     * @param token
     */
    GatewayClient.prototype.updateChannelHotel = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/ota/xbedChannelHotel/updateChannelHotel", params, token);
    };
    /**
     * 编辑门店介绍
     * @param params
     * @param channelHotelId 	门店Id（必传）
     * @param introduction 门店介绍
     * @param token
     */
    GatewayClient.prototype.updateHotelIntro = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/ota/xbedChannelHotel/updateHotelIntro", params, token);
    };
    /**
     * 获取房型信息（信息房）
     * @param channelRoomTypeId 渠道房型Id
     * @param token
     */
    GatewayClient.prototype.getInfoRoom = function (roomTypeId, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/ota/xbedChannelRoomType/getRoomTypeDetail", { roomTypeId: roomTypeId }, token);
    };
    /**
     * 编辑房型信息
     * @param name 房型名称
     * @param operatorName 操作人
     * @param roomTypeId 	房型Id（required）
     * @param roomTypeStatus 房型状态
     * @param token
     */
    GatewayClient.prototype.editRoomType = function (name, operatorName, roomTypeId, status, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/ota/xbedChannelRoomType/editRoomType", { name: name, operatorName: operatorName, roomTypeId: roomTypeId, status: status }, token);
    };
    /**
     * 编辑feizhu房型名称
     * @param
     */
    GatewayClient.prototype.editRoomTypeFeizhu = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/ota/xbedChannelRoomType/editRoomType", params, token);
    };
    /**
     * 楼宇批量解绑房间
     * @param ids
     */
    GatewayClient.prototype.unbindRelationRoomByIds = function (ids, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/roomInfo/listUpdateBuildingNull", { ids: ids }, token);
    };
    /**
     * 获取打包列表
     * @param buildingId 	楼宇Id
     * @param page
     * @param roomName 	房名
     * @param roomNo 房号
     * @param roomTypeId 房型Id
     * @param rows
     */
    GatewayClient.prototype.getRoomDockingList = function (buildingId, page, roomName, roomNo, roomTypeId, rows, token) {
        var reqData = { page: page, roomTypeId: roomTypeId, rows: rows };
        if (buildingId) {
            reqData.buildingId = buildingId;
        }
        if (roomName) {
            reqData.roomName = roomName;
        }
        if (roomNo) {
            reqData.roomNo = roomNo;
        }
        return this.preparePostRequest(this.gatewayUrl + "api/oms/ota/xbedChannelRoomDocking/getRoomDockingList", reqData, token);
    };
    /**
     * 省市门店下拉框
     */
    GatewayClient.prototype.citiesHotellist = function (param, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/chain/querySelectList", param, token);
    };
    /**
     * 查询未打包房间列表
     * @param roomTypeId 渠道房型ID
     * @param token
     */
    GatewayClient.prototype.getUnpackagedRoomList = function (roomTypeId, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/ota/xbedChannelRoomType/getUnpackagedRoomList", { roomTypeId: roomTypeId }, token);
    };
    /**
     * 新增打包
     * @param createName 	创建人
     * @param roomIds 房间Id,e.g. "188,189"
     * @param roomTypeId 房型Id
     * @param token
     */
    GatewayClient.prototype.addRoomDocking = function (createName, roomIds, roomTypeId, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/ota/xbedChannelRoomDocking/addRoomDocking", { createName: createName, roomIds: roomIds, roomTypeId: roomTypeId }, token);
    };
    /**
     * 查询门店详情基本信息
     * @param channelHotelId 	门店Id
     * @param token
     */
    GatewayClient.prototype.getChannelHotelInfo = function (channelHotelId, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/ota/xbedChannelHotel/getChannelHotelInfo", { channelHotelId: channelHotelId }, token);
    };
    /**
     * 新增房型
     * @param channelHotelId 渠道门店Id
     * @param channelId 渠道Id
     * @param name 房型名称
     * @param operatorName 操作人
     * @param token
     */
    GatewayClient.prototype.addRoomType = function (channelHotelId, channelId, name, operatorName, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/ota/xbedChannelHotel/addRoomType", { channelHotelId: channelHotelId, channelId: channelId, name: name, operatorName: operatorName }, token);
    };
    /**
     * 删除房型
     * @param channelId 渠道Id
     * @param operatorName 	操作人姓名
     * @param roomTypeId 	房型Id
     * @param xbedHotelId xbed门店Id
     * @param token
     */
    GatewayClient.prototype.deleteRoomType = function (channelId, operatorName, roomTypeId, xbedHotelId, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/ota/xbedChannelHotel/deleteRoomType", { channelId: channelId, operatorName: operatorName, roomTypeId: roomTypeId, xbedHotelId: xbedHotelId }, token);
    };
    /**
     * 删除打包
     * @param roomId 房间Id
     * @param roomTypeId 房型Id
     * @param updateName 更新人
     * @param token
     */
    GatewayClient.prototype.cancelRoomDocking = function (roomId, roomTypeId, updateName, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/ota/xbedChannelRoomDocking/cancelRoomDocking", { roomId: roomId, roomTypeId: roomTypeId, updateName: updateName }, token);
    };
    /**
     * 更换取信息房
     * @param roomId 房间Id
     * @param roomTypeId 房型Id
     * @param updateName 更新人
     * @param token
     */
    GatewayClient.prototype.changeInfoRoomDocking = function (roomId, roomTypeId, updateName, token) {
        return this.preparePostRequest(this
            .gatewayUrl + "api/oms/ota/xbedChannelRoomDocking/changeInfoRoomDocking", { roomId: roomId, roomTypeId: roomTypeId, updateName: updateName }, token);
    };
    /**
     * 更换取价房
     * @param roomId 房间Id
     * @param roomTypeId 房型Id
     * @param updateName 更新人
     * @param token
     */
    GatewayClient.prototype.changeRoomDocking = function (roomId, roomTypeId, updateName, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/ota/xbedChannelRoomDocking/changeRoomDocking", { roomId: roomId, roomTypeId: roomTypeId, updateName: updateName }, token);
    };
    //////////////////////////  打包房型 End  //////////////////////////
    /**
     * 获取七牛云上传token
     * @param source
     * @param isPrivate
     */
    GatewayClient.prototype.getUploadToken = function (source, isPrivate, token) {
        if (isPrivate === void 0) { isPrivate = 0; }
        return this.prepareGetRequest(this.gatewayUrl + "api/material/getQiNiuToken", { source: source, isPrivate: isPrivate }, token);
    };
    /////////////////////// 短信发送Start  ///////////////////////
    /**
     * 查询oms发送短信的记录
     * @param startTime 查询开始时间
     * @param endTime 查询结束时间
     * @param keyword 关键字
     * @param phone 手机号码
     * @param page
     * @param size
     * @param token
     */
    GatewayClient.prototype.smsRecords = function (startTime, endTime, keyword, phone, page, size, token) {
        var reqData = { startTime: startTime, endTime: endTime, page: page, size: size };
        if (phone) {
            reqData.phone = phone;
        }
        if (keyword) {
            reqData.keyword = keyword;
        }
        return this.prepareRequest(this.gatewayUrl + "api/oms/smsRecords", {}, 'get', token, reqData);
    };
    /**
     * 发送文字短信
     * @param businessCode 业务码。如：OMS
     * @param content 短信内容
     * @param operator 操作人
     * @param phone 接收短信手机号
     * @param source 1-oms
     * @param token
     */
    GatewayClient.prototype.sentText = function (businessCode, content, operator, phone, source, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/sms/sentText", { businessCode: businessCode, content: content, operator: operator, phone: phone, source: source }, token);
    };
    /////////////////////// 短信发送End  ///////////////////////
    /////////////////////// 报表接口End  ///////////////////////
    /**
     * 修改子入住单对账单状态
     * @param id 对账单id
     * @param operator 操作人
     * @param remark 备注
     * @param state 状态（type=1时 1未对账 2已对账 3异常）（type=2时 1未收款 2已收款 3异常）
     * @param type 类型
     * @param token
     */
    GatewayClient.prototype.updateCheckinInfoCheckState = function (id, operator, remark, state, type, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/analysis/check/updateCheckinInfoCheckState", { id: id, operator: operator, remark: remark, state: state, type: type }, 'put', token, { id: id, operator: operator, remark: remark, state: state, type: type });
    };
    /**
     * 修改支付单对账单状态
     * @param id 对账单id
     * @param operator 操作人
     * @param remark 备注
     * @param state 状态（type=1时 1未对账 2已对账 3异常）（type=2时 1未收款 2已收款 3异常）
     * @param type 类型
     * @param token
     */
    GatewayClient.prototype.updatePayInfoCheckState = function (id, operator, remark, state, type, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/analysis/check/updatePayInfoCheckState", { id: id, operator: operator, remark: remark, state: state, type: type }, 'put', token, { id: id, operator: operator, remark: remark, state: state, type: type });
    };
    /**
     * 修改线下收款状态
     * @param id 记录id
     * @param operator 操作人
     * @param receiveWay 收款渠道
     * @param remark 备注
     * @param state 确认状态： 1 待确认 2 已确认 3 作废
     * @param token
     */
    GatewayClient.prototype.confirmPayState = function (id, operator, receiveWay, remark, state, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/analysis/check/confirmPayState", { id: id, operator: operator, receiveWay: receiveWay, remark: remark, state: state }, 'put', token, { id: id, operator: operator, receiveWay: receiveWay, remark: remark, state: state });
    };
    /**
     * 支付单项目列表
     * @param startDate 创建开始时间
     * @param endDate	创建结束时间
     * @param page 页数
     * @param size 页大小
     * @param order 订单号
     * @param payName 支付人姓名
     * @param payNo 支付单号
     * @param payWay 支付类型 1-ota渠道订单支付 2-wechat 微信 3-unionpay 银联 4-makeup 代客代付 5-alipay 支付宝支付 6-system 下单即支付成功 7-银联（线下） 8-支付宝（线下） 9-微信（线下） 10-现金（线下） 11-其他（线下）
     * @param project 项目 1-房费 2-押金 3-增值服务 4-旧数据迁移 5-超时支付成功
     * @param source 订单来源 0-微信端 1-去哪儿 2-IOS端 3-安卓端 4-OMS 5-携程 6-业主APP 7-美团 8-长租 9-雅尔康 10-其他 11-空港 12-去哪儿 13-艺龙 14-miniProgram 15-同程旅行 16-小猪短租 17-飞猪旅行 18-途家 19-公司客（邮件）20-airbnb 21-驴妈妈 22-榛果民宿 73-ota_去哪儿 74-蚂蚁短租 75-ota_美团
     *
     * @param token
     */
    GatewayClient.prototype.payList = function (params, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/order/payList", params, 'get', token, params);
    };
    /**
     * 查询子入住单报表
     * @param page 页数
     * @param size 页大小
     * @param accountState 对账状态 1-未对账 2-已对账 3-异常
     * @param beginCheckinTime 起始入住日期
     * @param endCheckinTime 结束入住时间
     * @param beginCheckoutTime 起始退房时间
     * @param endCheckoutTime 结束退房时间
     * @param orderNo 订单号
     * @param orderSource 订单来源 0-微信端 1-去哪儿 2-IOS端 3-安卓端 4-OMS 5-携程 6-业主APP 7-美团 8-长租 9-雅尔康 10-其他 11-空港 12-去哪儿 13-艺龙 14-miniProgram 15-同程旅行 16-小猪短租 17-飞猪旅行 18-途家 19-公司客（邮件）20-airbnb 21-驴妈妈 22-榛果民宿 73-ota_去哪儿 74-蚂蚁短租 75-ota_美团
     * @param otaNo OTA单号
     * @param phone 预订手机
     * @param receiptState 收款状态
     * @param token
     */
    GatewayClient.prototype.listCheckinInfoReport = function (params, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/analysis/check/listCheckinInfoReport", params, 'get', token, params);
    };
    /**
     * 查询子入住单状态明细
     * @param id 对账单id
     * @param token
     */
    GatewayClient.prototype.listCheckinInfoDetailInfo = function (id, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/analysis/check/listCheckinInfoDetailInfo", { id: id }, 'get', token, { id: id });
    };
    /**
     * 查询对账收款导入记录
     * @param startDate 开始时间
     * @param endDate 结束时间
     * @param page 页码
     * @param size 页大小
     * @param token
     */
    GatewayClient.prototype.listCheckResult = function (params, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/analysis/check/listCheckResult", params, 'get', token, params);
    };
    /**
     * 查询支付单报表
     * @param params
     * @param startDate 支付开始日期
     * @param endDate 支付结束日期
     * @param page 页码
     * @param size 页大小
     * @param accountState 对账状态 1-未对账 2-已对账 3-异常
     * @param orderNo 订单号
     * @param orderSource 订单来源 0-微信端 1-去哪儿 2-IOS端 3-安卓端 4-OMS 5-携程 6-业主APP 7-美团 8-长租 9-雅尔康 10-其他 11-空港 12-去哪儿 13-艺龙 14-miniProgram 15-同程旅行 16-小猪短租 17-飞猪旅行 18-途家 19-公司客（邮件）20-airbnb 21-驴妈妈 22-榛果民宿 73-ota_去哪儿 74-蚂蚁短租 75-ota_美团
     * @param otaNo OTA单号
     * @param payNo 支付单号
     * @param payType 支付方式 1 ota渠道订单支付 2 wechat 微信 3 unionpay 银联 4 makeup 代客代付 5 alipay 支付宝支付 6 system 下单即支付成功 7 银联（线下） 8 支付宝（线下） 9 微信（线下） 10 现金（线下） 11 其他（线下）
     * @param receiptState 收款状态 1未收款 2已收款 3异常
     * @param settlementNo 结算单号
     * @param token
     */
    GatewayClient.prototype.listPayInfoReport = function (params, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/analysis/check/listPayInfoReport", params, 'get', token, params);
    };
    /**
     * 查询支付单状态明细
     * @param id 对账单id
     */
    GatewayClient.prototype.listPayInfoDetailInfo = function (id, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/analysis/check/listPayInfoDetailInfo", { id: id }, 'get', token, { id: id });
    };
    /**
     * 查询线下支付确认收款表
     * @param params
     * @param page 页码
     * @param size 页大小
     * @param startDate 支付开始时间
     * @param endDate 支付结束时间
     * @param orderNo 订单号
     * @param orderSource 订单来源 0-微信端 1-去哪儿 2-IOS端 3-安卓端 4-OMS 5-携程 6-业主APP 7-美团 8-长租 9-雅尔康 10-其他 11-空港 12-去哪儿 13-艺龙 14-miniProgram 15-同程旅行 16-小猪短租 17-飞猪旅行 18-途家 19-公司客（邮件）20-airbnb 21-驴妈妈 22-榛果民宿 73-ota_去哪儿 74-蚂蚁短租 75-ota_美团
     * @param payNo 支付单号
     * @param payWay 支付方式 1 ota ota渠道订单支付 2 wechat 微信 3 unionpay 银联 4 makeup 代客代付 5 alipay 支付宝支付 6 system 下单即支付成功 7 7 银联（线下） 8 8 支付宝（线下） 9 9 微信（线下） 10 10 现金（线下） 11 11 其他（线下）
     * @param status 确认状态：1待确认 2已确认 3作废
     * @param token
     */
    GatewayClient.prototype.listOfflinePayment = function (params, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/analysis/check/listOfflinePayment", params, 'get', token, params);
    };
    /**
     * 查询订单统计报表
     * @param params
     * @param page 页码
     * @param size 页大小
     * @param startDate 创建开始时间
     * @param endDate 创建结束时间
     * @param name 预订人姓名
     * @param orderNo 订单号
     * @param otherNo 渠道单号
     * @param phone 手机号
     * @param source 订单来源 0-微信端 1-去哪儿 2-IOS端 3-安卓端 4-OMS 5-携程 6-业主APP 7-美团 8-长租 9-雅尔康 10-其他 11-空港 12-去哪儿 13-艺龙 14-miniProgram 15-同程旅行 16-小猪短租 17-飞猪旅行 18-途家 19-公司客（邮件）20-airbnb 21-驴妈妈 22-榛果民宿 73-ota_去哪儿 74-蚂蚁短租 75-ota_美团
     * @param status 订单进度 1未开始 2进行中 3已结束 4取消
     * @param token
     */
    GatewayClient.prototype.orderReport = function (params, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/order/orderReport", params, 'get', token, params);
    };
    /**
     * 查询丽家会清洁布草报表
     *
     *  @param hotspotName 热点Id（根据需求这里可以是热点Id或者热点名称）
     *  @param rows 每页查询数量（分页）
     *  @param roomName 房间名称
     *  @param  city 城市名
     *  @param queryStartDate 结束日期（***必传***）
     *  @param chainName 门店Id（根据需求这里可以是门店Id或者门店名称）
     *  @param page 页码（分页）
     *  @param queryEndDate 开始日期（***必传***）
     *  @param province 省份名
     *  @param  roomId 房间Id
     *  @param  ownerName 业主姓名
     */
    GatewayClient.prototype.getCleanLinenReport = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/analysis/cleanLinenReport/getCleanLinenReport", params, token);
    };
    /**
     * 查询丽家会易耗品报表
     *
     *  @param ownerName 业主姓名
     *  @param roomId 房间Id
     *  @param queryStartDate 结束日期（***必传***）
     *  @param hotspotId 热点Id（根据需求这里可以是热点Id或者热点名称）
     *  @param page 页码（分页）
     *  @param roomName 房间名称
     *  @param province 省份
     *  @param chainName 门店Id（根据需求这里可以是门店Id或者门店名称）
     *  @param queryEndDate 开始日期（***必传***）
     *  @param rows 每页查询数（分页）
     *  @param city 城市
     */
    GatewayClient.prototype.getBillRoomConsumables = function (params, token) {
        return this.preparePostRequest(this
            .gatewayUrl + "api/oms/analysis/cleanLinenReport/getBillRoomConsumables", params, token);
    };
    /**
     * 查询丽家会易耗品城市列表
     *
     *  @param provinceName 省份名
     */
    GatewayClient.prototype.queryCleanCityList = function (provinceName, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/analysis/cleanLinenReport/queryCityList", { provinceName: provinceName }, token);
    };
    /**
     * 查询丽家会易耗品省份列表
     *
     */
    GatewayClient.prototype.queryCleanProvinceList = function (token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/analysis/cleanLinenReport/queryProvinceList", {}, token);
    };
    /**
     * 查询丽家会易耗品门店列表
     *
     *  @param provinceName 省份名
     *  @param cityName 城市名
     */
    GatewayClient.prototype.queryChainList = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/analysis/cleanLinenReport/queryChainList", params, token);
    };
    /**
     * 查询丽家会易耗品热点列表
     *
     * @param provinceName 省份名
     * @param cityName 城市名
     */
    GatewayClient.prototype.queryHotspotList = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/analysis/cleanLinenReport/queryHotspotList", params, token);
    };
    /**
     * 查询房间营收报表
     * @param curYearMonth 结算月份
     * @param isImported 0 未结算，1 已结算， 2 已打款
     * @param owner 业主(搜索业主姓名、手机号)
     * @param roomId 房间ID(搜索蓝主人房间ID、Xbed房间ID)
     * @param xbedRoomName Xbed房间名(搜索Xbed房间名)
     * @param xbedRoomNo 房号(搜索房号)
     * @param page 页数
     * @param size 每页行数
     * @param token
     */
    GatewayClient.prototype.queryRoomsMonthIncomeList = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/analysis/listRoomMonthIncome", params, token);
    };
    /**
     * 查询业主营收报表
     * @param curYearMonth 结算月份
     * @param isImported 0 未结算，1 已结算， 2 已打款
     * @param owner 业主(搜索业主姓名、手机号)
     * @param page 页数
     * @param size 每页行数
     * @param token
     */
    GatewayClient.prototype.queryOwnerRoomsMonthList = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/analysis/listOwnerRoomMonth", params, token);
    };
    /**
     * 年月列表
     */
    GatewayClient.prototype.queryYearMouth = function (token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/analysis/queryYearMonthList", '', token);
    };
    /////////////////////// 报表接口End  ///////////////////////
    /////////////////////// Order 接口相关 Start  ///////////////////////
    /**
     * 扫码支付
     * @param authCode 支付条码
     * @param operator 操作人
     * @param orderNo 订单号
     * @param payType 支付类型 2-微信；3-银联；5-aplipay
     * @param token
     */
    GatewayClient.prototype.barcodePay = function (authCode, operator, orderNo, payType, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/order/pay/barcodePay", { authCode: authCode, operator: operator, orderNo: orderNo, payType: payType }, token);
    };
    /**
     * 前台下单接口
     * @param activityId 指定执行活动id,不选择任何活动请传递 -1
     * @param arrivalTime 预计到店时间
     * @param bargainMoney 押金金额
     * @param beginDate	订单开始时间
     * @param cardCode 使用卡券code
     * @param channelCommission 渠道佣金
     * @param discount 折扣金额
     * @param discountId 优惠Id
     * @param endDate 订单结束时间
     * @param invoicePrice 发票金额
     * @param name 下单时填写的用户称呼
     * @param orderPrice 订单总价
     * @param otherChannelExpenses 渠道其他费用
     * @param otherNo 渠道订单号
     * @param realPrice 订单应付
     * @param receivedPrice 实收
     * @param remark 备注
     * @param rentType 租房类型 1-短租，2-长租
     * @param roomIds 多个房间用数组逗号隔开
     * @param roomTypeId 房型id
     * @param source 订单来源
     * @param userId 下单人ID
     * @param userPay 实付
     * @param xdollar 使用xdollar数量
     */
    GatewayClient.prototype.frontDestOrder = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/order/frontDestOrder", params, token);
    };
    /**
     * 获取优惠类型
     * @param type 	优惠类型分类	number	可选值: 1:代下单优惠类型(默认); 2:前台下单类型;
     */
    GatewayClient.prototype.getDiscountType = function (type, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/order/discountType/list", { type: type }, token);
    };
    /**
     * 下单接口
     * @param activityId 指定执行活动id,不选择任何活动请传递 -1
     * @param arrivalTime 预计到店时间
     * @param bargainMoney 押金金额
     * @param beginDate	订单开始时间
     * @param cardCode 使用卡券code
     * @param channelCommission 渠道佣金
     * @param discount 折扣金额
     * @param discountId 优惠Id
     * @param endDate 订单结束时间
     * @param invoicePrice 发票金额
     * @param name 下单时填写的用户称呼
     * @param orderPrice 订单总价
     * @param otherChannelExpenses 渠道其他费用
     * @param otherNo 渠道订单号
     * @param realPrice 订单应付
     * @param receivedPrice 实收
     * @param remark 备注
     * @param rentType 租房类型 1-短租，2-长租
     * @param roomIds 多个房间用数组逗号隔开
     * @param roomTypeId 房型id
     * @param source 订单来源
     * @param userId 下单人ID
     * @param userPay 实付
     * @param xdollar 使用xdollar数量
     */
    GatewayClient.prototype.bookOrder = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/order/bookOrder", params, token);
    };
    /**
     * 查询可预订房间
     * @param beginDate 开始时间
     * @param chainId	门店ID
     * @param city 城市名
     * @param custRoomName 房间名
     * @param custRoomNo	房间号
     * @param endDate	结束时间
     * @param hotspotId	热点ID
     * @param hotspotPowerIds	热点权限范围
     * @param page 页码
     * @param roomIds	房间ID数组
     * @param roomTypeName 房型名称
     * @param size 每页大小
     * @param tag	标签条件
     */
    GatewayClient.prototype.omsCanOrderRoom = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/roomInfo/omsCanOrderRoom", params, token);
    };
    /**
     * 查询房间押金
     * @param roomId 房间ID
     * @param token
     */
    GatewayClient.prototype.roomGuarantee = function (roomId, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/RoomGuarantee/room", { roomId: roomId }, token);
    };
    /**
     * 模糊查询子标签
     * @param cnameWay 标签全路径
     * @param tagCode 标签码
     * @param valueCount
     * @param token
     */
    GatewayClient.prototype.getSubTag = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/tagApi/room/getSubTag", params, token);
    };
    /**
     * 计算实收价格
     * @param activityId 活动ID
     * @param beginDate 订房开始时间
     * @param endDate 订房结束时间
     * @param roomIds 房间ID数组
     * @param source 订单来源ID
     */
    GatewayClient.prototype.calculatePrice = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/order/calculatePrice", params, token);
    };
    /**
     * 查询房间价格
     * @param beginDateTime 开始时间
     * @param endDateTime 结束时间
     * @param orderCheckinTime 订单预入住时间
     * @param roomId 房间ID
     * @param stat 状态
     * @param token
     */
    GatewayClient.prototype.calculateNormalInfo = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/calendar/normal/info", params, token);
    };
    /**
     * 查询短租退款单列表
     * @param endDate
     * @param orderNo
     * @param page
     * @param refundStat
     * @param size
     * @param startDate
     */
    GatewayClient.prototype.queryShortRentList = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/refund/short/listByDate", params, token);
    };
    /**
     * 提交退款信息
     * @param deductionImgList
     * @param deductionList
     * @param deductionMoneyList
     * @param id
     * @param operator
     * @param remark
     */
    GatewayClient.prototype.subRefundInfo = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/refund/short/submit", params, token);
    };
    /**
     * 手动退款
     * @param activeMoney
     * @param bankName
     * @param receiveAccount
     * @param id
     * @param receiveSource
     * @param refundChannel
     * @param sourceId
     * @param userName
     * @param remark
     */
    GatewayClient.prototype.refundByHand = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/refunds/short/confirm", params, token);
    };
    /**
     * 删除入住人
     * @param id
     * @param infoId
     * @param orderNo
     * @param token
     */
    GatewayClient.prototype.delCheckiner = function (id, infoId, orderNo, token) {
        return this.prepareRequest(this.gatewayUrl + "api/auth/userInfo/delCheckinPerson", { id: id, infoId: infoId, orderNo: orderNo }, 'delete', token, { id: id, infoId: infoId, orderNo: orderNo });
    };
    /**
     * 添加入住人
     * @param checkinId
     * @param phone
     * @param token
     * @param userName
     */
    GatewayClient.prototype.addCheckiner = function (checkinId, phone, userName, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/auth/OMS/addCheckiners", { checkinId: checkinId, phone: phone, userName: userName }, token);
    };
    /**
     * 获取有效的账务
     * @param checkinId
     * @param page
     * @param pageSize
     * @param token
     */
    GatewayClient.prototype.getUnfinishConsumptions = function (checkinId, page, size, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/consumption/getUnfinishConsumptions", { checkinId: checkinId, page: page, size: size }, token);
    };
    /////////////////////// Order 接口相关 End  ///////////////////////
    /////////////////////// 停用单相关接口Start  ///////////////////////
    /**
     * 停用单列表查询接口
     * @param chainId 门店ID
     * @param city 城市名
     * @param endDate 创建结束时间
     * @param hotspotId 热点ID
     * @param hotspotPowerIds 热点权限范围
     * @param page 当前页
     * @param roomIdOrNo 房间ID或者房间号
     * @param size 每页大小
     * @param startDate 创建开始时间
     * @param stat 停用单状态  0-新建 1-开始 2-结束 3-停用取消(已开始) 4-未开始取消
     * @param stopEndDate 停用预结束时间
     * @param stopNo 停用单号
     * @param stopStartDate 停用预开始时间
     * @param type 停用单类型 1-待解约停用 2-设施维修停用 3-长租房停用 4-参观停用 5-预订停用 6-其它原因
     * @param token
     */
    GatewayClient.prototype.stopList = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/stop/list", params, token);
    };
    /**
     * 取消停用单接口
     * @param stopId 停用单ID
     * @param token
     */
    GatewayClient.prototype.stopCancel = function (stopId, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/stop/cancel", { stopId: stopId }, 'put', token, { stopId: stopId });
    };
    /////////////////////// 停用单相关接口End  ///////////////////////
    /////////////////////// 省市区接口 Start  ///////////////////////
    /**
     * 下拉列表联动选择
     *
     *  @param parentId 父级Id 不传表示查询省份列表  传表示查询对应Id下的子级列表
     */
    GatewayClient.prototype.getDistrictSelective = function (parentId) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/district/getSelective", parentId ? { parentId: parentId } : {}, '');
    };
    /**
     * 修改省、市、区县
     *
     *  @param isHotCity 是否为热门城市（限编辑城市时）
     *  @param id id（必传）
     *  @param order 权重值
     *  @param custName 展示名称
     *  @param cityPic 城市图片（限编辑城市时）
     */
    GatewayClient.prototype.updateDistrict = function (isHotCity, id, order, custName, cityPic, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/district/updateDistrict", { isHotCity: isHotCity, id: id, order: order, custName: custName, cityPic: cityPic }, 'put', token, { isHotCity: isHotCity, id: id, order: order, custName: custName, cityPic: cityPic });
    };
    /**
     * 区县列表
     *
     *  @param rows 行数
     *  @param provinceId 所属省份Id
     *  @param page 页数
     *  @param sort 排序方式
     *  @param search 查询关键字
     *  @param orderBy 排序字段
     *  @param cityId 所属城市Id
     */
    GatewayClient.prototype.getDistrictCounties = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/district/getCounties", params, token);
    };
    /**
     * 城市列表
     *
     *  @param sort 排序方式
     *  @param provinceId 所属省份Id
     *  @param page 页数
     *  @param orderBy 排序字段
     *  @param isHotCity 是否为热门城市 1是0否
     *  @param search 查询关键字
     *  @param rows 行数
     */
    GatewayClient.prototype.getDistrictCities = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/district/getCities", params, token);
    };
    /**
     * 省份列表
     *
     *  @param sort 排序方式
     *  @param rows 行数
     *  @param search 查询关键字
     *  @param page 页数
     *  @param orderBy 排序字段
     */
    GatewayClient.prototype.getDistrictProvinces = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/district/getProvinces", params, token);
    };
    /**
     * 查询所有城市或有房间的城市
     * @param getAllCity
     */
    GatewayClient.prototype.listAllCity = function (getAllCity, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/cityList/listAllCity", { getAllCity: getAllCity }, token);
    };
    /////////////////////// 省市区接口  End   ///////////////////////
    /////////////////////// 营销管理  Start   ///////////////////////
    /**
     * 批量发放优惠码
     *
     *  @param promoCodeIds 优惠码id数组
     *  @param issuer 发放人
     */
    GatewayClient.prototype.batchIssuedPromoCode = function (promoCodeIds, issuer, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/marketing/promoCode/batchIssuedPromoCode", { promoCodeIds: promoCodeIds, issuer: issuer }, token);
    };
    /**
     * 通过cardId查询所有的码
     *
     *  @param isReceive 1已领取2未领取，默认为0
     *  @param isGrant 1已发放2未发放，默认为0
     *  @param page
     *  @param cardId
     *  @param size
     *  @param size
     *  @param size
     */
    GatewayClient.prototype.getCodesByCardId = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/marketing/promoCode/getCodesByCardId", params, token);
    };
    /////////////////////// 营销管理  End   ///////////////////////
    /////////////////////// 发票管理  Start   ///////////////////////
    /**
     * 发票管理 -> 冲红发票
     * @param id
     * @param omsAccount
     * @param reason 冲红理由
     * @param token
     */
    GatewayClient.prototype.elecInvoiceRevoke = function (id, omsAccount, reason, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/order/elecInvoice/revoke", { id: id, omsAccount: omsAccount, reason: reason }, 'delete', token, { id: id, omsAccount: omsAccount, reason: reason });
    };
    /**
     * 发票管理 -> 取消发票
     * @param id
     * @param omsAccount oms账号
     * @param remark 备注
     */
    GatewayClient.prototype.cancelInvoice = function (id, omsAccount, remark, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/order/invoice/cancel", { id: id, omsAccount: omsAccount, remark: remark }, token);
    };
    /**
     * 发票管理 -> 更新快递
     * @param express 快递公司
     * @param expressFee 快递费
     * @param expressNo 快递单号
     * @param expressState 发票状态。0-未开票，1-等待寄出，2-已寄出，4-取消开票
     * @param invoiceNo 发票号码
     * @param type 1-增值税普通发票；2-增值税专用发票
     * @param token
     */
    GatewayClient.prototype.updateInvoiceExpress = function (params, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/order/signExpress", params, 'put', token, params);
    };
    /**
     *
     * @param id
     * @param token
     */
    GatewayClient.prototype.updateElecInvoiceState = function (id, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/order/elecInvoice/updateState", { id: id }, 'put', token, { id: id });
    };
    /**
     * 发票管理 -> 查询
     * @param startDate
     * @param endDate
     * @param size
     * @param page
     * @param source 1 - 用户；2 - OMS
     * @param orderNo
     * @param invoiceType 1-纸质；2-电子
     * @param paperState 发票状态
     * @param elecState 开票状态
     * @param title 发票抬头
     * @param invoiceNo 发票号码
     * @param invoiceInfo 收票信息
     * @param token
     */
    GatewayClient.prototype.includeElecInvoice = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/order/invoice/includeElecInvoice", params, token);
    };
    /**
     *
     * @param id
     * @param omsAccount
     * @param remark
     * @param token
     */
    GatewayClient.prototype.appendInvoiceRemark = function (id, omsAccount, remark, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/order/invoice/appendRemark", { id: id, omsAccount: omsAccount, remark: remark }, token);
    };
    /**
     *
     * @param id
     * @param email 重发邮件的邮箱
     * @param token
     */
    GatewayClient.prototype.resendElecInvoiceByEmail = function (id, email, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/order/elecInvoice/resendEmail", { id: id, email: email, token: token }, token);
    };
    /**
     * @param checkinInfoId
     * 查看子入住单密码
     */
    GatewayClient.prototype.getOpenPwd = function (checkinInfoId, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/order/checkinInfo/getOpenPwd", checkinInfoId, token);
    };
    /**
     * 根据入住单查询订单详情
     * @param checkinId
     */
    GatewayClient.prototype.checkinDetailByCheckinId = function (checkinId, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/order/oms/checkinV3", { checkinId: checkinId }, token);
    };
    /**
     * 订单开票管理开具发票
     * @param account oms账号
     * @param address 收件人地址
     * @param applyName 申请人姓名
     * @param applyPhone 申请人手机号
     * @param city 城市code
     * @param cityName 城市名
     * @param county 区县code
     * @param countyName 区县名
     * @param email email
     * @param expressFee 快递费
     * @param invoiceMoney 发票金额
     * @param invoiceNo 发票号码
     * @param invoiceType 发票类型：1纸质 2电子
     * @param orderNo 开票订单
     * @param orderPrice 订单金额
     * @param phone 手机号码
     * @param price 开票金额
     * @param province 省code
     * @param provinceName 省名
     * @param realMoney 实付
     * @param realname 实付人
     * @param remark 备注
     * @param taxpayerId 税号
     * @param title 发票抬头
     * @param titleType 发票新增抬头类型：1-个人；2-企业
     * @param type 发票类型。1-增值税普通发票，2-增值税专用发票
     * @param userId 用户id
     * @param token
     */
    GatewayClient.prototype.addInvoice = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/order/invoiceManage/addInvoice", params, token);
    };
    /////////////////////// 发票管理  End     ///////////////////////
    /////////////////////// 客服短信评价接口 start  ///////////////////////
    /**
     *
     * @param callDateBegin 呼入开始时间
     * @param callDateEnd 呼入结束时间
     * @param callType 1呼入2呼出
     * @param content 评价内容
     * @param createdDate 创建时间
     * @param customerAreaCode 区号
     * @param endDate 挂机时间
     * @param evaluateDate 评价时间
     * @param evaluateType 评价状态，1未评2已评价
     * @param id
     * @param noType 客户电话1固话2手机
     * @param pageSize 每页显示多少条
     * @param phone 客户电话
     * @param seatNo 座席号
     * @param smsType 短信发送状态1成功0失败/未发送
     * @param startRow 第几页
     * @param subId
     * @param talkType 通话状态，1成功0失败
     * @param uniqueId
     * @param token
     */
    GatewayClient.prototype.queryEvaluateList = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/toolapi/listEvaluate", params, token);
    };
    /////////////////////// 客服短信评价接口 End    ///////////////////////
    /////////////////////// 功能统计 begin    ///////////////////////
    /**
     * 功能统计
     * @param code 功能code
     * @param userAgent 用户浏览器版本
     */
    GatewayClient.prototype.monitorFnCount = function (params) {
        return this.preparePostRequest(this.gatewayUrl + "api/monitor/fnCount", params);
    };
    /////////////////////// 功能统计 End    ///////////////////////
    ///////////////////////////// 清洁单 ////////////////////////////////////////
    /**
     * 今日清洁单数据
     */
    GatewayClient.prototype.findTodayData = function (token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/xbclean/xbCleanOrder/findTodayDatas", {}, 'get', token, {});
    };
    /**
     * 查询所有房间
     * @param chainId 门店Id
     */
    GatewayClient.prototype.queryRoomListForCleanOrder = function (params, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/xbclean/xbCleanOrder/roomList", params, 'get', token, params);
    };
    /**
     * 查询所有门店
     */
    GatewayClient.prototype.queryChainListForCleanOrder = function (token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/xbclean/xbCleanOrder/chainList", {}, 'get', token, {});
    };
    /**
     * 查询扣费项列表
     * @param page 页数
     * @param pageSize 行数
     */
    GatewayClient.prototype.queryPnsFeeCostList = function (page, pageSize, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/xbclean/xbCleanOrder/pnsFeeCostList", {
            page: page,
            pageSize: pageSize
        }, 'get', token, {
            page: page,
            pageSize: pageSize
        });
    };
    /**
     * 清洁单查询
     * @param serviceDateStart 服务时间起
     * @param city 城市
     * @param orderStatus 清洁单状态（0未接单，1已接单，2到达房间，3开门成功，4清洁盘点完成，5离房成功，6已核查
     * @param xbedOrderNo xbed订单号
     * @param cleaner 接单人（姓名或手机号）
     * @param orderNo 清洁单号
     * @param cleanTypeId 清洁类型Id
     * @param hotspotId 热点Id
     * @param chainId 门店Id
     * @param startDate 创建日期起
     * @param roomName 房号
     * @param serviceDateEnd 服务时间止
     * @param pageSize 行数
     * @param page 页数
     * @param orderType 单类型（1.正常清洁单，2.指派清洁单，3.人工结单，4.取消清洁单，5自动派单）
     * @param endDate 创建日期止
     */
    GatewayClient.prototype.queryCleanOrderList = function (params, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/xbclean/xbCleanOrder/query", params, 'get', token, params);
    };
    /**
     * 人工建单
     * @param xbedCheckinId xbed入住单号
     * @param plan 触发方案
     * @param xbedOrderNo xbed订单号
     * @param roomId 房间Id
     * @param cleanSource 来源（OMS人工建单为3）
     * @param createName 创建人
     * @param serviceDate 服务时间
     */
    GatewayClient.prototype.addCleanOrder = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/xbclean/xbCleanOrder/add", params, token);
    };
    /**
     * 取消清洁单
     * @param cancelReason 取消原因
     * @param id 清洁单Id
     * @param updateName 更新人
     * @param updateRoomStatusSwitch 是否修改房态：1是，0否
     */
    GatewayClient.prototype.cancelCleanOrder = function (cancelReason, id, updateName, updateRoomStatusSwitch, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/xbclean/xbCleanOrder/cancelCleanOrder", {
            cancelReason: cancelReason,
            id: id,
            updateName: updateName,
            updateRoomStatusSwitch: updateRoomStatusSwitch
        }, 'put', token, {
            cancelReason: cancelReason,
            id: id,
            updateName: updateName,
            updateRoomStatusSwitch: updateRoomStatusSwitch
        });
    };
    /**
     * 指派单
     * @param id 清洁单Id
     * @param cleanerAccount 管家账号
     * @param updateName 更新人
     */
    GatewayClient.prototype.assignCleanOrder = function (id, cleanerAccount, updateName, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/xbclean/xbCleanOrder/assignOrder", {
            id: id,
            cleanerAccount: cleanerAccount,
            updateName: updateName
        }, token);
    };
    /**
     * 查询物品设置
     * @param roomId 房间Id
     * @param plan 触发方案
     */
    GatewayClient.prototype.findItemType = function (roomId, plan, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/xbclean/xbCleanOrder/findItemType", {
            roomId: roomId,
            plan: plan
        }, 'get', token, {
            roomId: roomId,
            plan: plan
        });
    };
    /**
     * 根据清洁单Id查询扣费项
     * @param cleanOrderId 清洁单Id
     */
    GatewayClient.prototype.queryListCostByCleanOrderId = function (cleanOrderId, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/xbclean/xbCleanOrder/listCostByCleanOrderId", {
            cleanOrderId: cleanOrderId
        }, 'get', token, {
            cleanOrderId: cleanOrderId
        });
    };
    /**
     * 清洁单接单日志
     * @param id 清洁单Id
     */
    GatewayClient.prototype.findCleanOrderLogs = function (id, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/xbclean/xbCleanOrder/findLog", {
            id: id
        }, 'get', token, {
            id: id
        });
    };
    /**
     * 清洁单留言查询
     * @param cleanOrderId 清洁单Id
     */
    GatewayClient.prototype.queryCleanOrderMessageList = function (cleanOrderId, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/xbclean/xbCleanOrder/orderMessageList", {
            cleanOrderId: cleanOrderId
        }, 'get', token, {
            cleanOrderId: cleanOrderId
        });
    };
    /**
     * 结束清洁单
     * @param updateName 更新人
     * @param id 清洁单Id
     */
    GatewayClient.prototype.overCleanOrder = function (updateName, id, finishReason, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/xbclean/xbCleanOrder/overCleanOrder", {
            finishReason: finishReason,
            updateName: updateName,
            id: id
        }, 'put', token, {
            finishReason: finishReason,
            updateName: updateName,
            id: id
        });
    };
    /**
     * 已通过审核管家账号
     * @param page 页码
     * @param size 每页的数量
     * @param account 手机号
     * @param userName 管家名字
     */
    GatewayClient.prototype.getCleanerAccountAcceptData = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/xbclean/xbCleanOrder/cleanerAccountAcceptData", params, token);
    };
    /**
     * 清洁单图片查询
     * @param cleanOrderId 清洁单Id
     */
    GatewayClient.prototype.findImgsByCleanOrderId = function (cleanOrderId, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/xbclean/xbCleanOrder/findImgsByCleanOrderId", {
            cleanOrderId: cleanOrderId
        }, 'get', token, {
            cleanOrderId: cleanOrderId
        });
    };
    /**
     * 热点工作人员
     */
    GatewayClient.prototype.findHotSpotCleaner = function (token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/xbclean/xbCleanOrder/findHotSpotCleaner", {}, 'get', token, {});
    };
    /**
     * 城市/热点/门店联动查询
     * @param city 指定城市
     * @param sourceId 指定查询一条记录
     * @param type 查询类型 0 查询所有 1查询热点 2查询门店
     * @param token
     */
    GatewayClient.prototype.querySelectListForCleanOrder = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/xbclean/xbCleanOrder/querySelectList", params, token);
    };
    /**
     * 查询核查记录
     * @param cleanOrderId 清洁单Id
     */
    GatewayClient.prototype.findCheckDetailForCleanOrder = function (cleanOrderId, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/xbclean/xbCleanOrder/findCheckDetail", {
            cleanOrderId: cleanOrderId
        }, 'get', token, {
            cleanOrderId: cleanOrderId
        });
    };
    /**
     * 易耗品补充记录查询
     * @param cleanOrderId 清洁单Id
     * @param token
     */
    GatewayClient.prototype.findConsumableForCleanOrder = function (cleanOrderId, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/xbclean/xbCleanOrder/findConsumable", {
            cleanOrderId: cleanOrderId
        }, token);
    };
    ///////////////////////////// 清洁单 ////////////////////////////////////////
    /////////////////////////// 清洁项目管理 ///////////////////////////////////////
    /**
     * 清洁步骤项目管理-&gt;项目列表
     * @param pageSize
     * @param page
     * @param search 查询关键字
     */
    GatewayClient.prototype.cleanStepList = function (params, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/xbclean/xbCleanObject/list", {}, 'get', token, params);
    };
    /**
     * 清洁步骤项目管理-&gt;新增项目
     * @param createName
     * @param description 描述
     * @param name 名称
     */
    GatewayClient.prototype.cleanStepAdd = function (params, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/xbclean/xbCleanObject/add", params, 'post', token);
    };
    /**
     * 清洁步骤项目管理-&gt;编辑项目
     * @param updateName 更新人
     * @param used 是否可用
     * @param id
     * @param description 描述
     * @param name 项目名称
     */
    GatewayClient.prototype.cleanStepEdit = function (params, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/xbclean/xbCleanObject/edit", params, 'put', token, params);
    };
    /**
     * 清洁步骤项目管理-&gt;删除项目
     * @param id 步骤项目Id
     */
    GatewayClient.prototype.cleanStepDel = function (id, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/xbclean/xbCleanObject/del", {
            id: id
        }, 'delete', token, {
            id: id
        });
    };
    /**
     * 核查项目管理 -&gt; 核查项目列表
     * @param pageSize 行数
     * @param page 页数
     */
    GatewayClient.prototype.cleanCheckList = function (params, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/xbclean/xbCheckObject/list", {}, 'get', token, params);
    };
    /**
     * 核查项目管理 -&gt; 新建核查项目
     * @param name 项目名称
     * @param type 核查类型(1关联物品,2无物品)
     * @param goodsIds 关联物品Id(type&#x3D;2时不传)
     * @param createName 创建人
     * @param pic 核查图片
     * @param detail 核查明细(json数组，type&#x3D;1时不传)
     * @param checkTime 核查时间(ms)
     */
    GatewayClient.prototype.cleanCheckAdd = function (params, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/xbclean/xbCheckObject/add", params, 'post', token);
    };
    /**
     * 核查项目管理 -&gt; 删除核查项目
     * @param id 项目Id
     */
    GatewayClient.prototype.cleanCheckDel = function (id, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/xbclean/xbCheckObject/del", {
            id: id
        }, 'put', token, {
            id: id
        });
    };
    /**
     * 核查项目管理 -&gt; 编辑核查项目
     * @param pic 核查图片
     * @param checkTime 核查时间(ms)
     * @param type 核查类型(1关联物品,2无物品)
     * @param detail 核查明细(json数组，type&#x3D;1时不传)
     * @param name 项目名称
     * @param id 项目Id
     * @param createName 创建人
     * @param goodsIds 关联物品Id(type&#x3D;2时不传)
     */
    GatewayClient.prototype.cleanCheckEdit = function (params, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/xbclean/xbCheckObject/edit", params, 'put', token, params);
    };
    /**
     * 核查项目管理 -&gt; 获取可选物品列表
     * @param goodsName 物品名称
     * @param checkObjectId 核查项目Id
     * @param secondaryCatalog 二级类型
     * @param goodsCatalog 一级类型
     * @param isStandard 是否标配 1是0否
     */
    GatewayClient.prototype.getCleanCheckGoodsList = function (params, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/xbclean/xbCheckObject/getGoodsList", {}, 'get', token, params);
    };
    /////////////////////////// 清洁项目管理 ///////////////////////////////////////
    /////////////////////////// 清洁单类型管理 ///////////////////////////////////////
    /**
     * 清洁类型管理 -&gt; 清洁类型列表
     * @param page 页数
     * @param pageSize 行数
     * @param search 关键字
     */
    GatewayClient.prototype.queryListForCleanType = function (params, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/xbclean/xbCleanType/list", params, 'get', token, params);
    };
    /**
     * 清洁类型管理 -&gt; 新建清洁类型
     * @param description 描述
     * @param itemDetail 项目明细(逗号&quot;,&quot;分割)；1更换床品，2更换毛巾，3补充易耗品
     * @param name 名称
     * @param itemType 项目配置类型：1固定配置，2建单时人工配置
     * @param createName 创建人
     */
    GatewayClient.prototype.addCleanType = function (params, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/xbclean/xbCleanType/add", params, 'post', token);
    };
    /**
     * 清洁类型管理 -&gt; 编辑清洁类型
     * @param itemType 项目配置类型：1固定配置，2建单时人工配置
     * @param name 名称
     * @param itemDetail 项目明细(逗号&quot;,&quot;分割)；1更换床品，2更换毛巾，3补充易耗品
     * @param updateName 更新人
     * @param used 是否可用（1是0否） 传0即为删除该项目
     * @param description 备注
     * @param id
     */
    GatewayClient.prototype.editCleanType = function (params, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/xbclean/xbCleanType/edit", params, 'put', token, params);
    };
    /**
     * 清洁类型管理 -&gt; 清洁项目列表
     * @param cleanTypeId 清洁类型Id
     */
    GatewayClient.prototype.queryListObjectForCleanType = function (cleanTypeId, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/xbclean/xbCleanType/listObject", {
            cleanTypeId: cleanTypeId
        }, 'get', token, {
            cleanTypeId: cleanTypeId
        });
    };
    /**
     * 清洁类型管理 -&gt; 删除清洁类型-项目关系
     * @param cleanTypeId
     */
    GatewayClient.prototype.delObjectForCleanType = function (cleanTypeId, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/xbclean/xbCleanType/delObject", {
            cleanTypeId: cleanTypeId
        }, 'put', token, {
            cleanTypeId: cleanTypeId
        });
    };
    /**
     * 清洁类型管理 -&gt; 编辑清洁类型-项目关系
     * @param data
     */
    GatewayClient.prototype.editObjectForCleanType = function (data, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/xbclean/xbCleanType/editObject", {
            data: data
        }, 'put', token, {
            data: data
        });
    };
    /**
     * 清洁类型管理 -&gt; 核查项目列表
     * @param cleanTypeId 清洁类型Id
     */
    GatewayClient.prototype.queryListCheckObject = function (cleanTypeId, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/xbclean/xbCleanType/listCheckObject", {
            cleanTypeId: cleanTypeId
        }, 'get', token, {
            cleanTypeId: cleanTypeId
        });
    };
    /**
     * 清洁类型管理 -&gt; 编辑清洁类型-核查项目关系
     * @param data
     */
    GatewayClient.prototype.editCheckObject = function (data, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/xbclean/xbCleanType/editCheckObject", {
            data: data
        }, 'put', token, {
            data: data
        });
    };
    /**
     * 清洁类型管理 -&gt; 删除清洁类型-核查项目关系
     * @param cleanTypeId
     */
    GatewayClient.prototype.delCheckObject = function (cleanTypeId, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/xbclean/xbCleanType/delCheckObject", {
            cleanTypeId: cleanTypeId
        }, 'put', token, {
            cleanTypeId: cleanTypeId
        });
    };
    /**
     * 获取核查物品列表
     * @param token
     */
    GatewayClient.prototype.getGoodsList = function (token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/xbclean/xbCheckObject/getGoodsList", {}, token);
    };
    /////////////////////////// 清洁单类型管理 ///////////////////////////////////////
    /////////////////////////// 管家信息账号管理 ///////////////////////////////////////
    /**
     * 管家列表
     * @param accept 状态（是否可接单 1是0否 -1全部）
     * @param account 管家账号
     * @param isAuth 是否已认证（1是 0否 -1全部）
     * @param userName 用户名
     * @param page
     * @param size
     * @param token
     */
    GatewayClient.prototype.queryCleanerList = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/admin/xbCleaner/list", params, token);
    };
    /**
     * 管家列表-开通/禁止接单
     * @param accept 状态（是否可接单 1是0否）
     * @param id 管家Id
     * @param updateName 操作人
     * @param token
     */
    GatewayClient.prototype.acceptCleaner = function (params, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/admin/xbCleaner/updateAccept", params, 'put', token, params);
    };
    /**
     * 管家列表-开通/禁止查房
     * @param id 管家Id
     * @param isWatcher 是否是查房者（1是 0否）
     * @param updateName 操作人
     * @param token
     */
    GatewayClient.prototype.watcherCleaner = function (params, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/admin/xbCleaner/edit", params, 'put', token, params);
    };
    /**
     * 修改管家信息
     * @param bankBranchName 支行名
     * @param bankName 开户行
     * @param bankNo 银行账号
     * @param cardId 身份证号
     * @param city 城市
     * @param deposit 押金
     * @param district 区县
     * @param hotspotId 热点ID
     * @param hotspotName 热点名称
     * @param id 管家id
     * @param isAgree 是否签订协议
     * @param isAuth 是否身份认证
     * @param province 省份
     * @param remark 备注
     * @param updateName 操作人
     * @param userName 用户名
     * @param token
     */
    GatewayClient.prototype.editCleanerList = function (params, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/admin/xbCleaner/edit", params, 'post', token);
    };
    /**
     * 获取热点列表
     * @param cityName 城市名称
     * @param token
     */
    GatewayClient.prototype.queryCleanerHotspotList = function (cityName, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/admin/xbCleaner/queryHotspotList", cityName, token);
    };
    /**
     * 管家详情
     * @param id 管家id
     * @param token
     */
    GatewayClient.prototype.queryCleanerInfo = function (id, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/admin/xbCleaner/getCleanerById", id, token);
    };
    /**
     * 房东信息列表
     * @param createDateEnd 创建日期止（yyyy-MM-dd）
     * @param createDateStart 创建日期起（yyyy-MM-dd）
     * @param examineState 身份验证状态（1未验证 2未审核 3审核通过 4审核失败）
     * @param lastLoginEnd 最后登录日期止（yyyy-MM-dd）
     * @param lastLoginStart 最后登录日期起（yyyy-MM-dd）
     * @param mobile 电话号码
     * @param name 姓名
     * @param page 页数
     * @param size 行数
     * @param source 注册来源
     * @param token
     */
    GatewayClient.prototype.queryLandlordList = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/admin/xbLandlord/landlordList", params, token);
    };
    /////////////////////////// 管家信息账号管理 ///////////////////////////////////////
    /////////////////////////// 物品管理 ///////////////////////////////////////
    /**
     * 物品管理 -&gt;删除物品
     * @param goodsId 物品Id
     * @param updateName 更新人
     */
    GatewayClient.prototype.delGoodsForCleanerGoodsList = function (goodsId, updateName, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/xbclean/svGoods/del", {
            goodsId: goodsId,
            updateName: updateName
        }, 'put', token, {
            goodsId: goodsId,
            updateName: updateName
        });
    };
    /**
     * 物品管理 -&gt;新增物品
     * @param goodsAttribute 属性
     * @param goodsDesc 规格
     * @param goodsModel 型号/品牌
     * @param goodsCatalog 一级类型
     * @param createName 创建人
     * @param isStandard 是否标配
     * @param secondaryCatalog 二级类型
     * @param goodsName 物品名称
     * @param remark 备注
     * @param stockNumber 进销存产品编号
     */
    GatewayClient.prototype.addGoodsForCleanerGoodsList = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/xbclean/svGoods/add", params, token);
    };
    /**
     * 物品管理 -&gt;核查设置
     * @param unit 核查数量
     * @param goodsId 物品Id
     * @param checkOptions 核查步骤
     * @param updateName
     * @param checkPic 核查图片（url）
     * @param checkType 核查类型（0不核查 1数量标准 2步骤标准 3数量+步骤）
     */
    GatewayClient.prototype.setGoodsCheckForCleanerGoodsList = function (params, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/xbclean/svGoods/setGoodsCheck", params, 'put', token, params);
    };
    /**
     * 物品管理 -&gt;物品列表
     * @param pageSize 行数
     * @param isStandard 是否标配（1是0否）
     * @param page 页数
     * @param goodsName 名称
     * @param secondaryCatalog 二级类别
     * @param goodsAttribute 属性
     * @param checkType 核查类型
     * @param stockNumber 物料编号
     * @param goodsCatalog 物品类别（一级类别）
     */
    GatewayClient.prototype.queryCleanerGoodsList = function (params, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/xbclean/svGoods/list", params, 'get', token, params);
    };
    /**
     * 物品管理 -&gt;物品类别下拉列表
     * @param parentId 父级Id
     */
    GatewayClient.prototype.getSelectiveForCleanerGoodsList = function (params, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/xbclean/svGoods/getSelective", params, 'get', token, params);
    };
    /**
     * 物品管理 -&gt;修改物品
     * @param goodsAttribute 属性
     * @param goodsName 物品名称
     * @param goodsModel 型号/品牌
     * @param isStandard 是否标配
     * @param secondaryCatalog 二级类型
     * @param goodsId 物品Id
     * @param remark 备注
     * @param goodsCatalog 一级类型
     * @param goodsDesc 规格
     * @param updateName 创建人
     * @param stockNumber 进销存产品编号
     * @param terminal 应用终端1xbed 2房东端 3xbed+房东端
     */
    GatewayClient.prototype.editGoodsForCleanerGoodsList = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/xbclean/svGoods/edit", params, token);
    };
    /**
     * 物品管理 -&gt;获取所有物品类别
     * @param token
     */
    GatewayClient.prototype.getGoodsCatalogList = function (token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/xbclean/svGoods/getGoodsCatalogList", {}, 'get', token, {});
    };
    //////////////////////////////////////////////////////////////////
    GatewayClient.prototype.ownerMonthlyBillReport = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/analysis/listOwnerRoomMonth", params, token);
    };
    /**
     * 修改单条业主营收月结数据
     * @param checkRoomIncome 核查房费收入
     * @param id ID
     * @param roomPresented 本月可提现
     * @param lastMonthBalance 上月结余
     */
    GatewayClient.prototype.updateOwnerRoomMonth = function (params, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/analysis/updateOwnerRoomMonth", params, 'put', token, params);
    };
    /**
     * 修改单条房间月结数据
     * @param roomPresented 房间可提现
     * @param invoiceTax 发票税费
     * @param miscellaneousExpenses 其它杂项费
     * @param manageMoney	 运营费
     * @param checkRoomIncome 核查渠房间收入
     * @param checkLinenWashMoney 洗涤费核查
     * @param checkConsumableMoney 核查易耗品
     * @param checkCleanCostMoney 核查清洁单费
     * @param checkXbedPlatformMoney 核查平台费
     * @param transactionFee 交易手续费
     * @param checkOwnerPromotionExpense 核查业主推广费
     * @param checkOtaPlatformMoney 核查渠道分销费
     * @param checkRoomPayable 核查房费应付
     * @param checkOwnerDiscount 核查业主优惠
     * @param checkRoomOriMoney 核查房费原价
     */
    GatewayClient.prototype.updateReRoomMonthIncome = function (params, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/analysis/updateReRoomMonthIncome", params, 'post', token);
    };
    /////////////////////////////////////////////////////////////////////
    /////////////////////////// 房间详情 ///////////////////////////////////////
    /**
     * 查询房间信息
     * @param roomId 房间Id
     */
    GatewayClient.prototype.queryRoomBasicInfo = function (roomId, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/roomInfo/room", { roomId: roomId }, token);
    };
    /**
     * 获取房间二维码
     * @param roomId 房间Id
     */
    GatewayClient.prototype.createQrCode = function (roomId, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/Room/createQrCode", { roomId: roomId }, token);
    };
    /**
     * 更改房间销售状态
     * @param flag 销售状态（1销售中 2删除 3下架 4筹建中 5售前展示）
     * @param roomId 房间id
     * @param user 操作人
     */
    GatewayClient.prototype.updataRoomFlag = function (flag, roomId, user, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/roomInfo/updateRoomFlag", { flag: flag, roomId: roomId, user: user }, 'put', token, { flag: flag, roomId: roomId, user: user });
    };
    /**
     * 查询房间绑定物品
     * @param roomId 房间Id
     */
    GatewayClient.prototype.queryBindingRoomGoodsList = function (roomId, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/roomInfo/listRoomGoods", { roomId: roomId }, 'get', token, { roomId: roomId });
    };
    /**
     * 新增房间物品
     * @param roomdId 房间id
     * @param goodsList
     * @param token
     * e.g. data=[{"goodsId":"51","roomId":"8171","goodsNum":"1","createName":"dev"}]
     */
    GatewayClient.prototype.addRoomGoods = function (roomId, goodsList, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/roomInfo/addRoomGoods", { roomId: roomId, goodsList: goodsList }, token);
    };
    /**
     * 更新未关联门店楼宇房间省市区
     * @param roomId 房间id
     * @param province 省
     * @param city 市
     * @param district 区
     */
    GatewayClient.prototype.updateRoomArea = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/roomInfo/updateRoomAddressProCiDis.do", params, token);
    };
    /**
     * 批量删除房间图片
     * @param ids 图片(素材)id 多个id使用,号分隔
     * @param token
     */
    GatewayClient.prototype.delRoomFlacks = function (ids, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/roomInfo/listRemoveRoomFlack", { ids: ids }, token);
    };
    /**
     * 查询房间修改记录
     * @param page
     * @param pageSize
     * @param roomId
     * @param token
     */
    GatewayClient.prototype.editRoomLog = function (page, pageSize, roomId, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/roomEditRecord/list", { page: page, pageSize: pageSize, roomId: roomId }, token);
    };
    //////////////////////////////////////////////////////////////////
    /////////////////////////////// 飞猪 //////////////////////////////////
    /**
     * 新增飞猪门店
     * @param channelId 渠道ID（必传）
     * @param channelHotelName	飞猪门店名称 (必传)
     * @param xbedHotelId 门店ID（必传）
     * @param operatorName 操作人姓名（必传）
     * @param token
     */
    GatewayClient.prototype.addFeizhuChannelHotel = function (channelId, channelHotelName, xbedHotelId, operatorName, isDirectLink, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/ota/FzChannelHotel/addChannelHotel", { channelId: channelId, channelHotelName: channelHotelName, xbedHotelId: xbedHotelId, operatorName: operatorName, isDirectLink: isDirectLink }, token);
    };
    /**
     * 查询飞猪门店列表
     * @param channelHotelId 门店ID（必传）
     * @param page 页数
     * @param rows 每页数据量
     * @param status 打包状态筛选条件（1已打包，0未打包）
     * @param token
     */
    GatewayClient.prototype.queryFeizhuRoomTypeList = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/ota/FzChannelHotel/getRoomTypeList", params, token);
    };
    /**
     * 重新匹配门店
     * @param channelHotelId 门店ID(必传)
     * @param operatorName 操作人帐号(必传)
     * @param token
     */
    GatewayClient.prototype.matchChannelHotel = function (channelHotelId, operatorName, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/ota/FzChannelHotel/matchChannelHotel", { channelHotelId: channelHotelId, operatorName: operatorName }, token);
    };
    /**
     * 修改门店名称
     * @param channelHotelId 门店ID
     * @param channelHotelName 门店名称
     * @param operatorName 操作人姓名
     * @param token
     */
    GatewayClient.prototype.editChannelHotel = function (channelHotelId, channelHotelName, operatorName, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/ota/FzChannelHotel/editChannelHotel", { channelHotelId: channelHotelId, channelHotelName: channelHotelName, operatorName: operatorName }, token);
    };
    /**
     * 新增房型-飞猪
     * @param bedType 床型（必传）
     * @param bedTypeDesc 床型描述
     * @param bufferCount 缓存房量（必传）
     * @param name 房型名称（必传）
     * @param operatorName 操作人姓名（必传）
     * @param channelHotelId 门店Id（必传）
     * @param channelId 渠道ID（写死4）
     * @param ratePlanName 价格计划名称（必传）
     * @param token
     */
    GatewayClient.prototype.matchRoomType = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/ota/FzChannelHotel/matchRoomType", params, token);
    };
    /**
     * 修改缓存房量
     * @param bufferCount 缓存房量（必传）
     * @param operatorName 操作人（必传）
     * @param roomTypeId 房型ID（必传）
     * @param token
     */
    GatewayClient.prototype.updateBufferCount = function (bufferCount, operatorName, roomTypeId, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/ota/dailyInventory/updateBufferCount", { bufferCount: bufferCount, operatorName: operatorName, roomTypeId: roomTypeId }, token);
    };
    /**
     * 匹配房型（适用于匹配和重新匹配）
     * @param operatorName 操作人(必传)
     * @param ratePlanName 价格计划名称
     * @param roomTypeId 房型ID(必传)
     * @param token
     */
    GatewayClient.prototype.syncRoomTypeForFz = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/ota/FzChannelHotel/syncRoomType", params, token);
    };
    /**
     * 匹配房型（适用于匹配和重新匹配）
     * @param operatorName 操作人(必传)
     * @param ratePlanName 价格计划名称
     * @param roomTypeId 房型ID(必传)
     * @param token
     */
    GatewayClient.prototype.reSyncRoomTypeForFz = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/ota/FzChannelHotel/reSyncRoomType", params, token);
    };
    /**
     * 门店签约接口
     * @param hotelId
     * @param userName
     * @param email
     * @param phone
     */
    GatewayClient.prototype.sendHotelSignApplying = function (hotelId, userName, email, phone, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/ota/fzChannelHotel/sendHotelSignApplying", { hotelId: hotelId, userName: userName, email: email, phone: phone }, token);
    };
    /**
     * 修改销售状态
     * @param hotelId
     * @param saleStatusCode
     * @param token
     */
    GatewayClient.prototype.changeSaleStatus = function (hotelId, saleStatusCode, token) {
        return this.preparePostRequest(this.gatewayUrl + "ota/fzChannelHotel/changeSaleStatus", { hotelId: hotelId, saleStatusCode: saleStatusCode }, token);
    };
    /////////////////////////////// 星创俱乐部 //////////////////////////////////
    /**
     * 查询俱乐部列表
     * @param clubName 	俱乐部名称
     * @param clubNo 俱乐部编号
     * @param developer 开发人员姓名/手机号
     * @param endDate	创建日期止
     * @param maker	创客姓名/手机号
     * @param page	页数
     * @param size	行数
     * @param startDate	创建日期起
     * @param token
     */
    GatewayClient.prototype.queryClubList = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/Owner/Club/list", params, token);
    };
    /**
     * 检查俱乐部名称是否可用
     * @param name 	俱乐部名称
     * @param token
     */
    GatewayClient.prototype.checkClubName = function (name, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/Owner/Club/checkClubName", { name: name }, token);
    };
    /**
     * 编辑俱乐部名称
     * @param clubName 	俱乐部名称
     * @param id 	俱乐部名称
     * @param updateName 	俱乐部名称
     * @param token
     */
    GatewayClient.prototype.editClubName = function (clubName, id, updateName, token) {
        return this.prepareRequest(this.gatewayUrl + "api/oms/Owner/Club/edit", { clubName: clubName, id: id, updateName: updateName }, 'put', token, { clubName: clubName, id: id, updateName: updateName });
    };
    /**
     * 查看俱乐部所有成员
     * @param clubId 	俱乐部ID
     * @param token
     */
    GatewayClient.prototype.clubMemberList = function (clubId, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/Owner/Club/listMember", { clubId: clubId }, token);
    };
    /**
     * 根据蓝主人id查询签约意向对象
     * @param ownerId
     * @param token
     */
    GatewayClient.prototype.querySignIntentionInfo = function (ownerId, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/IntentionMakerInfo/selectByOwnerId", { ownerId: ownerId }, token);
    };
    /**
     * 修改签约意向对象
     * @param params
     * @param token
     */
    GatewayClient.prototype.editIntention = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/IntentionMakerInfo/edit", params, token);
    };
    /**
     * 修改签约意向对象
     * @param params
     * @param token
     */
    GatewayClient.prototype.addIntention = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/IntentionMakerInfo/add", params, token);
    };
    /**
     * 修改签约来源
     * @param clubId	俱乐部id	number
     * @param contractOnlineId	合同id	number
     * @param makerId	创客id	number
     * @param signSource	signSourceType为4、5时分别对应代理、子公司	string
     * @param signSourceType	签约类型：1 开发，2贵州样板事业部，3创客/俱乐部，4代理，5子公司	number
     * @param updateName	操作人	string
     */
    GatewayClient.prototype.putSignSource = function (params, token) {
        return this.preparePutRequest(this.gatewayUrl + "api/ContractOnline/changeContractSignSource", params, token);
    };
    /**
     * 查询代理
     */
    GatewayClient.prototype.getAgent = function (token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/agencyInfo/findUsing", '', token);
    };
    /**
     * 查询子公司
     */
    GatewayClient.prototype.getSubsidiary = function (token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/CompanyInfo/Usinglist", '', token);
    };
    /**
     * 根据蓝主人公司代理信息列表  新增
     * @param ownerId
     * @param token
     */
    GatewayClient.prototype.AgencyAdd = function (data, token) {
        return this.preparePostRequest(this.gatewayUrl + 'api/agencyInfo/add', data, token);
    };
    /**
     * 根据蓝主人公司代理信息列表 所有列表
     * @param ownerId
     * @param token
     */
    GatewayClient.prototype.getAgencyFindAll = function (data, token) {
        return this.prepareGetRequest(this.gatewayUrl + 'api/agencyInfo/findAll', data, token);
    };
    /**
     * 根据蓝主人公司代 编辑
     * @param ownerId
     * @param token
     */
    GatewayClient.prototype.updateAgency = function (data, token) {
        return this.preparePostRequest(this.gatewayUrl + 'api/agencyInfo/update', data, token);
    };
    /**
     * 根据蓝主人公司代理信息
     * @param ownerId
     * @param token
     */
    GatewayClient.prototype.getCompanyAgencyInfo = function (data) {
        return this.prepareGetRequest(this.gatewayUrl + 'api/agencyInfo/findUsing', {}, data);
    };
    /**
     * 修改合同收款记录
     * @param contractOnlineId	合同id	number
     * @param isPayBondFee	是否支付总保证金：1是，0否	number
     * @param isPayPlatformFee	是否支付总授权费：1是，0否	number
     * @param receipBondFee	实收总保证金，单位：分;	number
     * @param receipPlatformFee	实收总授权费，单位：分	number
     * @param updateName	操作人	string
     */
    GatewayClient.prototype.putContractFeeRecord = function (params, token) {
        return this.preparePutRequest(this.gatewayUrl + "api/ContractOnline/editReceipFeeRecord", params, token);
    };
    /**
     * 合同协议操作记录列表
     * @param contractOnlineId	合同id	number
     * @param page	页码	number
     * @param pageSize	每页数	number
     * @param keyword	查询的字符串	string
     */
    GatewayClient.prototype.getOperateRecord = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/ContractOnline/contractOperateRecordList", params, token);
    };
    /**
     * 房源匹配接口    同步到ruby的房源发布
     * @param json_data	json字符串
     */
    GatewayClient.prototype.postSetSync = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/ruby/roomManagement", params, token);
    };
    /////////////////////////////// 飞猪 //////////////////////////////////
    ////////////////////////////// 会员管理 ////////////////////////////////
    /**
     * 根据userid查询用户验证信息
     * @param userId
     */
    GatewayClient.prototype.queryUserById = function (userId, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/userInfo/findByUserId", userId, token);
    };
    /**
     * oms人脸照片验证
     * @param userId
     * @param imageFace
     * @param imgType
     * @param phone
     * @param auditStatus
     */
    GatewayClient.prototype.omsFaceAudit = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/userInfo/faceAudit", params, token);
    };
    /**
     * oms人工审核人脸
     * @param userId
     * @param imageFace
     * @param auditStatus
     */
    GatewayClient.prototype.omsFaceAuditHandle = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/userInfo/omsFaceAudit", params, token);
    };
    /**
     * oms身份证照片验证
     * @param backImg
     * @param frontImg
     * @param imgType
     * @param phone
     * @param userId
     */
    GatewayClient.prototype.omsCardAudit = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/userInfo/idAudit", params, token);
    };
    /**
     * oms港澳台身份验证 3.6.2
     * @param certificateAuditStatus	港澳台/外籍人士证件审核状态，1待审核 2 已验证 3审核不通过
     * @param certificateIdNo	证件号
     * @param certificateRejectReason	外籍人士证件审核不通过原因
     * @param certificateValid	证有效日期
     * @param image1	证正面
     * @param image2	人脸正面
     * @param imageType	决定图片获取方式1从微信的素材ID,2七牛url
     * @param name
     * @param userId
     */
    GatewayClient.prototype.certificateAudit = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/userInfo/certificateAudit", params, token);
    };
    /**
     * oms身份证验证
     * @param userId
     * @param backImg
     * @param frontImg
     * @param idValidDate
     * @param name
     * @param idNo
     * @param phone
     * @param state
     */
    GatewayClient.prototype.omsIdAudit = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/userInfo/omsIdAudit", params, token);
    };
    /**
     * 获取七牛私有token
     * @param imgUrl
     */
    GatewayClient.prototype.getPrivateToken = function (imgUrl, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/other/getPrivatePicUrl", { imgUrl: imgUrl }, token);
    };
    ////////////////////////////// 会员管理end /////////////////////////////
    ////////////////////////////// 渠道分析start /////////////////////////////
    /**
     * 渠道分析
     * @param channelId 标识
     * @param beginDate 开始时间格式yyyy-MM-dd （非空）
     * @param endDate 结束时间格式yyyy-MM-dd （非空）
     * @param page 页数
     * @param pageSize 每页数量
     * @param token 用户标识
     */
    GatewayClient.prototype.getAnalysisChannelList = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/analysis/channel/getChannelAnalysisList", params, token);
    };
    ////////////////////////////// 渠道分析end /////////////////////////////
    ////////////////////////////// 落地页start /////////////////////////////
    /**
     * 检查手机号码是否注册
     * @param phone 手机号码
     */
    GatewayClient.prototype.checkRegisterForLanding = function (phone) {
        return this.prepareGetRequest(this.gatewayUrl + "api/user/registerType", { phone: phone }, '');
    };
    /**
     * 注册
     * @param phone 手机号码
     * @param source 注册渠道来源 0微信公众号 1去呼呼 2IOS 3Android 4OMS 5携程 6业主会 7美团 8XBED 10办理入住时系统注册 11活动注册 12预订时系统注册 14OTA 15wap 16www 17长租 18微信落地页
     */
    GatewayClient.prototype.registerForLanding = function (phone, source) {
        return this.prepareGetRequest(this.gatewayUrl + "api/user/register", { phone: phone, source: source }, '');
    };
    ////////////////////////////// 落地页end /////////////////////////////
    ////////////////////////////// 企业信息管理start ////////////////////////////
    /**
     * 条件查询企业用户
     * @param extensionClerk
     * @param id
     * @param juridicalPerson
     * @param name
     * @param page
     * @param property
     * @param size
     */
    GatewayClient.prototype.queryCompanyList = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/enterprise/findByPage", params, token);
    };
    /**
     * 新增/修改企业
     * param address
     * param area
     * param businessLicenceUrL
     * param city
     * param discount
     * param extensionClerk
     * param juridicalPerson
     * param landlineTelephone
     * param licenseCode
     * param name
     * param phone
     * param property
     * param province
     * param scale
     * param id
     */
    GatewayClient.prototype.editCompany = function (params, token) {
        var url = params.id
            ? this.gatewayUrl + "api/oms/enterprise/edit"
            : this.gatewayUrl + "api/oms/enterprise/save";
        return this.preparePostRequest(url, params, token);
    };
    /**
     * 删除企业
     * @param id
     */
    GatewayClient.prototype.deleteCompany = function (id, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/enterprise/delete/" + id, {}, token);
    };
    /**
     * 查询推广员
     */
    GatewayClient.prototype.queryCms = function (token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/qrcode/all/list", {}, token);
    };
    /**
     * 修改企业用户员工
     * @param enterpriseId
     * @param id
     * @param mobile
     * @param name
     * @param registrationDate
     */
    GatewayClient.prototype.changeCompanyEmployees = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/EnterpriseStaff/edit", params, token);
    };
    /**
     * 企业员工信息导入
     * @param enterpriseId
     * @param file
     */
    GatewayClient.prototype.importEmployeesInfo = function (
        // params: {
        //   enterpriseId: number;
        //   file: object;
        // },
        enterpriseId, file, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/excel/importEnterpriseStaffInfo", { enterpriseId: enterpriseId, file: file }, token);
    };
    /**
     * 批量修改企业折扣
     * @param discount
     * @param ids
     */
    GatewayClient.prototype.changeCompanyDiscount = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/enterprise/editMore", params, token);
    };
    /**
     * 条件查询企业员工
     * @param enterpriseId
     * @param id
     * @param mobile
     * @param name
     */
    GatewayClient.prototype.queryCompanyEmployess = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/EnterpriseStaff/queryAll", params, token);
    };
    /**
     * 查看企业详情
     * @param id
     */
    GatewayClient.prototype.queryCompanyDetails = function (id, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/enterprise/queryDetail/" + id, {}, token);
    };
    /**
     * 条件企业用户报表
     * @param consumeEndfDate
     * @param consumeStartDate
     * @param extensionClerk
     * @param page
     * @param registrationEndDate
     * @param registrationStartDate
     * @param size
     */
    GatewayClient.prototype.queryCompanyUserReport = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/promotionReport/queryPromotionReport", params, token);
    };
    /**
     * 删除企业用户员工
     * @param id
     */
    GatewayClient.prototype.deleteCompanyUserEmployesss = function (id, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/EnterpriseStaff/delete/" + id, {}, token);
    };
    /**
     * 添加企业用户员工
     * @param enterpriseId
     * @param mobile
     * @param name
     */
    GatewayClient.prototype.addCompanyUserEmployess = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/EnterpriseStaff/save", params, token);
    };
    ////////////////////////////// 企业信息管理end /////////////////////////////
    ////////////////////////////// 智能设备start ///////////////////////////
    /**
     * 查询自助机型号列表
     */
    GatewayClient.prototype.queryMachineModelList = function (token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/machine/listmodel", {}, token);
    };
    /**
     * 查询自助机列表
     * @param chain
     * @param enable
     * @param machineCode
     * @param machineStatus
     */
    GatewayClient.prototype.queryMachineList = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/machine/list", params, token);
    };
    /**
     * 添加自助机
     * @param machineCode
     * @param machineModel
     */
    GatewayClient.prototype.addMachine = function (machineCode, machineModel, userId, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/machine/add", { machineCode: machineCode, machineModel: machineModel, userId: userId }, token);
    };
    /**
     * 删除自助机
     * @param machineCode
     */
    GatewayClient.prototype.delMachine = function (machineCode, userId, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/machine/delete", { machineCode: machineCode, userId: userId }, token);
    };
    /**
     * 编辑自助机信息
     * @param city
     * @param district
     * @param enable
     * @param latitudeLongitude
     * @param machineCode
     * @param province
     * @param street
     */
    GatewayClient.prototype.editMachineInfo = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/machine/update", params, token);
    };
    /**
     * 查询未绑定门店
     * @param machineCode
     */
    GatewayClient.prototype.unbindedRoom = function (machineCode, chain, page, pageSize, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms//chain/nobind/list", { machineCode: machineCode, chain: chain, page: page, pageSize: pageSize }, token);
    };
    /**
     * 查询已绑定门店
     * @param machineCode
     */
    GatewayClient.prototype.bindedRoom = function (machineCode, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/chain/list", { machineCode: machineCode }, token);
    };
    /**
     * 绑定门店到机器
     * @param ids
     * @param machineCode
     */
    GatewayClient.prototype.bindingRoom = function (ids, machineCode, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/chain/binding", { ids: ids, machineCode: machineCode }, token);
    };
    /**
     * 解绑门店
     * @param chainId
     * @param machineCode
     */
    GatewayClient.prototype.unbindRoom = function (chainId, machineCode, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/chain/untie", { chainId: chainId, machineCode: machineCode }, token);
    };
    /**
     * 根据id查询机器信息
     * @param id
     */
    GatewayClient.prototype.queryMachineInfoById = function (id, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/machine/find", { id: id }, token);
    };
    /**
     * 查询所有门锁
     * @param flter
     * @param orderBy
     * @param page
     * @param rows
     * @param sort
     */
    GatewayClient.prototype.queryAllLock = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/lockApi/queryAllRock", params, token);
    };
    /**
     * 获取门锁型号
     */
    GatewayClient.prototype.queryLockModel = function (token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/lockApi/queryAllRockModel", {}, token);
    };
    /**
     * 新增门锁
     * @param keySn
     * @param lockModelId
     * @param lockSn
     * @param netBoxSn
     * @param creator
     */
    GatewayClient.prototype.addLock = function (keySn, lockModelId, lockSn, netBoxSn, creator, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/lockApi/addDoorLockInfo", { keySn: keySn, lockModelId: lockModelId, lockSn: lockSn, netBoxSn: netBoxSn, creator: creator }, token);
    };
    /**
     * 更新门锁
     * @param keySn
     * @param lockId
     * @param lockModelId
     * @param lockSn
     * @param netBoxSn
     * @param stat
     * @param updater
     */
    GatewayClient.prototype.updataLock = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/lockApi/updateDoorLockInfo", params, token);
    };
    /**
     * 更新门锁数据
     * @param lockId
     */
    GatewayClient.prototype.refreshLock = function (lockId, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/lockApi/updateLockInfo", { lockId: lockId }, token);
    };
    /**
     * 更新门锁状态
     * @param lockId
     */
    GatewayClient.prototype.refreshLockState = function (lockId, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/lockApi/updateLockState", { lockId: lockId }, token);
    };
    /**
     * 校准门锁时间
     * @param lockId
     */
    GatewayClient.prototype.calibrateLockTime = function (lockId, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/lockApi/calibrationCurrTime", { lockId: lockId }, token);
    };
    /**
     * 获取开门记录
     * @param beginDate
     * @param endDate
     * @param lockId
     */
    GatewayClient.prototype.lockopenLotg = function (filter, page, size, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/lockApi/getLockOpenLog", { filter: filter, page: page, size: size }, token);
    };
    /**
     * 获取门锁动态信息
     * @param lockId
     */
    GatewayClient.prototype.getLockDynamicsInfo = function (lockId, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/lockApi/getLockInfo", { lockId: lockId }, token);
    };
    /**
     * 关联房间
     * @param installTime
     * @param lockId
     * @param roomId
     * @param roomName
     */
    GatewayClient.prototype.relateRoom = function (installTime, lockId, roomId, roomName, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/lockApi/addRoomDoorLock", { installTime: installTime, lockId: lockId, roomId: roomId, roomName: roomName }, token);
    };
    /**
     * 解除关联
     * @param id
     * @param operateUserName
     */
    GatewayClient.prototype.unbindRoomRelation = function (id, operateUserName, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/lockApi/removeRoomDoorLock", { id: id, operateUserName: operateUserName }, token);
    };
    /**
     * 获取门锁密码列表
     */
    GatewayClient.prototype.getLockPasswordList = function (lockId, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/lockApi/getLockPwdInfo", { lockId: lockId }, token);
    };
    /**
     * 重置密码
     * @param pwdId
     * @param pwdType
     * @param handlerName
     */
    GatewayClient.prototype.restLockPwd = function (pwdId, pwdType, handlerName, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/lockApi/restLockPwd", { pwdId: pwdId, pwdType: pwdType, handlerName: handlerName }, token);
    };
    /**
     * 设置即时密码
     * @param endTime
     * @param isMaster 是否主锁（允许为空）
     * @param lockId
     * @param pwdType 1客人密码 2管家密码 3超级密码 4长租密码 5即时密码
     * @param remark
     * @param roomId
     * @param sn
     * @param startTime YYYY-MM-DD HH:mm:ss
     * @param writeTime
     */
    GatewayClient.prototype.setJustTimePwd = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/lockApi/setRealTimePwd", params, token);
    };
    /**
     * 设置超级密码
     * @param endTime
     * @param isMaster 是否主锁（允许为空）
     * @param lockId
     * @param pwdType 1客人密码 2管家密码 3超级密码 4长租密码 5即时密码
     * @param remark
     * @param roomId
     * @param sn
     * @param startTime YYYY-MM-DD HH:mm:ss
     * @param writeTime
     */
    GatewayClient.prototype.setSupperPwd = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/lockApi/setRoomLockPwd", params, token);
    };
    /**
     * 设置长租密码
     * @param endTime
     * @param isMaster 是否主锁（允许为空）
     * @param lockId
     * @param pwdType 1客人密码 2管家密码 3超级密码 4长租密码 5即时密码
     * @param remark
     * @param roomId
     * @param sn
     * @param startTime YYYY-MM-DD HH:mm:ss
     * @param writeTime
     */
    GatewayClient.prototype.setLongTimePwd = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/lockApi/addLongRentPwd", params, token);
    };
    /**
     * 设置离线密码
     * @param params
     * @param token
     */
    GatewayClient.prototype.setofflinePwd = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/lockApi/addOfflinePwd/byDuration", params, token);
    };
    /**
     * 根据id获取门店信息
     * @param id
     */
    GatewayClient.prototype.getRoomInfoById = function (roomId, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/roomInfo/room", { roomId: roomId }, token);
    };
    ////////////////////////////// 智能设备end /////////////////////////////
    ////////////////////////////// 微信 start ////////////////////////////
    /**
     * 查询二维渠道列表
     * @param page 页数
     * @param pageSize 每页记录数
     * @param sourcesName 渠道名
     * @param token 用户唯一标识
     */
    GatewayClient.prototype.getSources = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/qrcode/getSources", params, token);
    };
    /**
     * 查询二维码列表
     * @param page 页数
     * @param pageSize 每页记录数
     * @param city 城市
     * @param province 省
     * @param cmsName 推广人员
     * @param sources 渠道名
     * @param token 用户唯一标识
     */
    GatewayClient.prototype.queryQrcodeList = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/qrcode/list", params, token);
    };
    /**
     * 新增二维码
     * @param city 城市
     * @param cityId 城市
     * @param cmsName 推广人员
     * @param keyword 关键词
     * @param name 二维码名称
     * @param province 省份
     * @param provinceId 省份
     * @param sources 二维码渠道
     * @param state 二维码状态 1：可用 2：不可用
     * @param token 用户唯一标识
     */
    GatewayClient.prototype.addQrcodeCreate = function (city, cityId, cmsName, keyword, name, province, provinceId, sources, state, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/qrcode/create", {
            city: city,
            cityId: cityId,
            cmsName: cmsName,
            keyword: keyword,
            name: name,
            province: province,
            provinceId: provinceId,
            sources: sources,
            state: state
        }, token);
    };
    /**
     * 编辑二维码
     * @param city 城市
     * @param cityId 城市id
     * @param cmsName 推广人员
     * @param keyword 关键词
     * @param name 二维码名称
     * @param province 省份
     * @param provinceId 省份id,
     * @param qrId 二维码Id
     * @param state 二维码状态 1：可用 2：不可用
     * @param token 用户唯一标识
     */
    GatewayClient.prototype.editQrcodeEdit = function (city, cityId, cmsName, keyword, name, province, provinceId, qrId, state, sources, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/qrcode/edit", {
            city: city,
            cityId: cityId,
            cmsName: cmsName,
            keyword: keyword,
            name: name,
            province: province,
            provinceId: provinceId,
            qrId: qrId,
            sources: sources,
            state: state
        }, token);
    };
    /**
     * 删除二维码
     * @param qrId 二维码id
     * @param token
     */
    GatewayClient.prototype.deleteQrcodeDelete = function (qrId, token) {
        return this.prepareRequest(this.gatewayUrl + "api/qrcode/delete", { qrId: qrId }, 'delete', token, { qrId: qrId });
    };
    /**
     * 添加/编辑 渠道
     * @param remark 备注
     * @param sources 渠道名
     * @param sourcesRate 费率
     * @param token
     */
    GatewayClient.prototype.updateSources = function (params, token) {
        // 根据请求参数有无id决定接口
        var reqUrl = params.scId
            ? this.gatewayUrl + "api/qrcode/editSources"
            : this.gatewayUrl + "api/qrcode/addSources";
        return this.preparePostRequest(reqUrl, params, token);
    };
    /**
     * 删除渠道
     * @param scId 渠道id
     * @param token
     */
    GatewayClient.prototype.deleteSources = function (scId, token) {
        return this.prepareRequest(this.gatewayUrl + "api/qrcode/delSources", { scId: scId }, 'delete', token, { scId: scId });
    };
    ////////////////////////////// 微信 end ////////////////////////////
    ////////////////////////////// 订单详情 start //////////////////////////
    /**
     * 判断是否可申请在住清洁
     * @param checkinId 入住单Id
     * @param orderNo 订单号
     * @param token
     */
    GatewayClient.prototype.checkinClean = function (checkinId, orderNo, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/auth/order/checkinClean", { checkinId: checkinId, orderNo: orderNo }, token);
    };
    ////////////////////////////// 订单详情 end //////////////////////////
    /**
     * 查询oms账号权限管理列表
     * @param params
     * @param token
     */
    GatewayClient.prototype.getUserDataList = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/newUserData", params, token);
    };
    /**
     * 获取所有的用户群组列表
     * @param token
     */
    GatewayClient.prototype.listAllGroups = function (token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/listAllGroups", {}, token);
    };
    /**
     * 新建oms用户
     * @param groupIds
     * @param password
     * @param username
     * @param token
     */
    GatewayClient.prototype.addUser = function (groupIds, password, username, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/addUser", { groupIds: groupIds, password: password, username: username }, token);
    };
    /**
     * 编辑oms用户
     * @param groupIds
     * @param password
     * @param username
     * @param token
     */
    GatewayClient.prototype.editUser = function (param, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/editUser", param, token);
    };
    /**
     * 删除oms用户
     * @param userId
     * @param token
     */
    GatewayClient.prototype.deleteUser = function (userId, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/deleteOmsUser", { userId: userId }, token);
    };
    /**
     * 获取oms用户群组
     * @param userId
     * @param token
     */
    GatewayClient.prototype.userGroups = function (userId, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/listUserGroups", { userId: userId }, token);
    };
    /**
     * oms删除用户房间数据范围
     * @param id
     * @param token
     */
    GatewayClient.prototype.deleteOmsUserRoomsRange = function (id, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/deleteOmsUserRoomsRange", { id: id }, token);
    };
    /**
     * 查询门店
     * @param chainName
     * @param city
     * @param token
     */
    GatewayClient.prototype.searchChain = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/chain/searchChain", params, token);
    };
    /**
     * oms查询用户房间数据范围
     * @param userId
     * @param token
     */
    GatewayClient.prototype.getOmsUserRoomsRange = function (userId, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/getOmsUserRoomsRange", { userId: userId }, token);
    };
    /**
     * 删除所有房间数据权限
     * @param userId
     * @param token
     */
    GatewayClient.prototype.deleteAllUserRoomsRange = function (userId, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/deleteAllUserRoomsRange", { userId: userId }, token);
    };
    /**
     * oms添加用户房间数据范围
     * @param omsNewRoomsRangeList
     * @param type 房间数据范围类型，1城市2行政区3门店
     * @param userId
     * @param value
     * @param token
     */
    GatewayClient.prototype.addOmsUserRoomsRange = function (param, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/batchAddOmsUserRoomsRange", param, token);
    };
    /**
     * oms查询用户房间数据范围
     * @param userId
     * @param token
     */
    GatewayClient.prototype.listRangeByUserId = function (userId, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/listRangeByUserId", { userId: userId }, token);
    };
    /**
     * 加所有房间数据权限
     * @param userId
     * @param token
     */
    GatewayClient.prototype.addAllUserRoomsRange = function (userId, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/AddAllUserRoomsRange", { userId: userId }, token);
    };
    /**
     * 中心仓城市列表
     * @param token
     */
    GatewayClient.prototype.centerCityList = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/admin/xbCenterRepository/getCityList", params, token);
    };
    /**
     * 中心仓省份列表
     * @param token
     */
    GatewayClient.prototype.centerProvinceList = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/admin/xbCenterRepository/getProvinceList", params, token);
    };
    /**
     * 城市中心仓列表
     * @param city 城市（Id）
     * @param page 页数
     * @param phone 联系电话
     * @param size  页大小
     * @param status 状态（1启用 0停用 -1全部）
     * @param token
     */
    GatewayClient.prototype.centerManagementList = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/admin/xbCenterRepository/list", params, token);
    };
    /**
     * 新建中心仓
     * @param city 城市
     * @param cityId 城市Id
     * @param createName 创建人（oms用户名）
     * @param district  区县
     * @param districtId 区县Id
     * @param latitude 纬度
     * @param longitude 经度
     * @param phone 联系电话
     * @param province  省份
     * @param provinceId 省份Id
     * @param repositoryName 仓库名称
     * @param status  状态（1启用 0停用）
     * @param stressAddress 街道地址
     * @param token
     */
    GatewayClient.prototype.addCenterManagement = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/admin/xbCenterRepository/add", params, token);
    };
    /**
     * 编辑中心仓
     * @param city 城市
     * @param cityId 城市Id
     * @param district  区县
     * @param districtId 区县Id
     * @param latitude 纬度
     * @param longitude 经度
     * @param phone 联系电话
     * @param province  省份名称
     * @param provinceId 省份Id
     * @param repositoryName 仓库名称
     * @param status  状态（1启用 0停用）
     * @param stressAddress 街道地址
     * @param updateName 更新人
     * @param token
     * @param id 中心仓Id
     */
    GatewayClient.prototype.editCenterManagement = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/admin/xbCenterRepository/edit", params, token);
    };
    /**
     * 城市中心仓数量
     * @param citys 城市中文编码LIst
     * @param token
     */
    GatewayClient.prototype.centerManagementHouseNum = function (param, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/centerwarehous/totalOfCity", param, token);
    };
    /**
     * 管家信息修改记录
     * @param cleanerId 管家Id（Id）
     * @param page 页数
     * @param size  行数
     * @param token
     */
    GatewayClient.prototype.editHousekeeperAccount = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/admin/xbCleaner/getModifyRecord", params, token);
    };
    /**
     * oms-调整单列表
     * @param adjustmentResultId 调整单号
     * @param audit 审批状态1、待复核、2、待审批、3、审批通过
     * @param checkinId 入住单
     * @param checkinInfoId 子入住单号
     * @param createEnd 创建日期结束时间
     * @param createStart 创建开始时间
     * @param orderNo 订单号
     * @param page 页数
     * @param size 行数
     * @param token
     */
    GatewayClient.prototype.getAdjustmentList = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/adjustment/list", params, token);
    };
    /**
     * oms-调整单详情
     * @param adjustmentResultId 调整单号
     * @param token
     */
    GatewayClient.prototype.getAdjustmentDetail = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/adjustment/details", params, token);
    };
    /**
     * oms-调整单复核
     * @param adjustmentResultId 调整单号
     * @param operator 操作人姓名
     * @param reviewNote 复核备注
     * @param reviewState 复核状态：1未审核，2已审核，3、已取消（不通过）
     * @param token
     */
    GatewayClient.prototype.getAdjustmentReview = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/adjustment/review", params, token);
    };
    /**
     * oms-调整单审批
     * @param adjustmentResultId 审批单号
     * @param approvalNote 审批备注
     * @param approvalState 审批状态：1未审核，2已审核，3、已取消（不通过）
     * @param operator 操作人
     * @param token
     */
    GatewayClient.prototype.getAdjustmentApproval = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/adjustment/approval", params, token);
    };
    /**
     * oms-新增调整单-根据订单订单号查询入住单
     * @param orderNo 订单号
     * @param token
     */
    GatewayClient.prototype.AddAdjustmentOrderNo = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/adjustment/searchCheckinByOrderNo", params, token);
    };
    /**
     * oms-新增调整单-根据入住单查询子入住单
     * @param checkinId 入住单id
     * @param token
     */
    GatewayClient.prototype.AddAdjustmentListByCheckinId = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/order/checkinInfo/listByCheckinId", params, token);
    };
    /**
     * oms-新增调整单-调整单-查询账务
     * @param checkinId 入住单id
     * @param checkinInfoId
     * @param orderNo
     * @param token
     */
    GatewayClient.prototype.AddAdjustmentListInfo = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/adjustment/getAdjustmentConsumptions", params, token);
    };
    /**
     * oms-新增调整单
     * @param actualCheckinTime 实际开始时间
     * @param actualCheckoutTime 实际结束时间
     * @param channelCommission OTA佣
     * @param channelCommissionDiff OTA佣(差额)
     * @param checkinId 入住表id（入住单id）
     * @param checkinInfoId 入住子单表id
     * @param createName 创建人姓名
     * @param orderNo 订单号
     * @param orgActualCheckinTime 实际开始时间（原入住单
     * @param orgActualCheckoutTime 实际结束时间（原入住单）
     * @param orgChannelCommission OTA佣（原入住单）
     * @param orgCreateName 创建人（原入住单）
     * @param orgOtherChannelExpenses 渠道活动费（原名“渠道其他费用”）（原入住单）
     * @param orgOwnerBear 业主优惠（原入住单）
     * @param orgOwnerPromotionExpense 业主推广费（原入住单）
     * @param orgPlatformPrice 平台服务费(原入住单)
     * @param orgPromotionExpenseBack 推广费返还（原入住单）
     * @param orgReceivedPrice Xbed实收（原入住单）
     * @param orgRoomPrice 房费（原入住单）
     * @param orgSettlementPrice 结算金额（原入住单）
     * @param orgShouldPay 应付（原子入住单）
     * @param orgUpdateName 更新姓名（原子入住单）
     * @param orgXbedBear xbed优惠
     * @param orgXbedPromotionExpense Xbed推广费
     * @param otherChannelExpenses 渠道活动费（原名“渠道其他费用”）
     * @param otherChannelExpensesDiff 渠道活动费(差额)
     * @param ownerBear 业主优惠
     * @param ownerBearDiff 业主优惠（差额）
     * @param ownerPromotionExpense 业主推广费
     * @param ownerPromotionExpenseDiff 业主推广费（差额）
     * @param platformPrice 平台服务费
     * @param platformPriceDiff 平台服务费（差额）
     * @param promotionExpenseBack 推广费返还
     * @param promotionExpenseBackDiff 推广费返还（差额）
     * @param reason 建单原因
     * @param receivedPrice Xbed实收
     * @param receivedPriceDiff Xbed实收（差额）
     * @param roomId 房间id
     * @param roomNightDiff 房晚(差额)
     * @param roomPrice 房费
     * @param roomPriceDiff 房费（差额）
     * @param settlementPrice 结算金额
     * @param settlementPriceDiff 结算金额（差额）
     * @param shouldPay 应付
     * @param shouldPayDiff 应付（差额）
     * @param updateName 更新人
     * @param xbedBear xbed优惠
     * @param xbedBearDiff xbed优惠（差额）
     * @param xbedPromotionExpense Xbed推广费
     * @param xbedPromotionExpenseDiff Xbed推广费（差额）
     * @param token
     */
    GatewayClient.prototype.addAdjustmentList = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/adjustment/insert", params, token);
    };
    /**
     * 管家即使账务列表
     * @param params
     * @param token
     */
    GatewayClient.prototype.getHostInfos = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/xbclean/xbCleanOrder/cleanerAccountAcceptData", params, token);
    };
    /**
     * 管家身份信息
     * @param id
     * @param token
     */
    GatewayClient.prototype.getVerifyInfo = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/admin/xbCleaner/getVerifyInfo", params, token);
    };
    /**
     * 人脸验证
     * @param cleanerId 	管家Id
     * @param imageCode  人脸验证图片
     * @param token
     */
    GatewayClient.prototype.faceRecognition = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/admin/xbCleaner/cleanerFaceRecognition", params, token);
    };
    /**
     * 身份证上传验证
     * @param cleanerId 管家Id
     * @param cardBackImgCode 	身份证背面图
     * @param cardFrontImgCode 身份证正面图
     * @param updateName 操作人
     * @param token
     */
    GatewayClient.prototype.authentication = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/admin/xbCleaner/authentication", params, token);
    };
    /**
     * 获取易耗品列表或根据名字查询
     */
    GatewayClient.prototype.consumableList = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/admin/MmConsumablePrice/list", params, token);
    };
    /**
     * 修改易耗品价格
     */
    GatewayClient.prototype.editConsumPrice = function (cityId, goodsList, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/admin/MmConsumablePrice/edit", { cityId: cityId, goodsList: goodsList }, token);
    };
    /**
     * 获获取布草列表或根据城市名称、商品名称查询
     */
    GatewayClient.prototype.washingList = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/admin/MmLinenPrice/list", params, token);
    };
    /**
     * 修改布草价格
     */
    GatewayClient.prototype.editWashingPrice = function (cityId, goodsList, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/admin/MmLinenPrice/edit", { cityId: cityId, goodsList: goodsList }, token);
    };
    /**
     * 领用归还单列表
     * @param account 管家手机
     * @param invoiceId 领用归还单号
     * @param orderNo 单据编号
     * @param page 	页数
     * @param pageSize 	每页数据量
     * @param receiptsType 单据类别（1—领用，2—归还）
     * @param userName 	管家名字
     * @param beginDate 	起始时间
     * @param endDate 		终止时间
     * @param approvalStatus 		审批状态
     * @param createJxcOrderStatus 		生成状态
     * @param repositoryName 			中心仓名
     * @param associatedCityName 			关联城市名
     */
    GatewayClient.prototype.MmReceiptReturnList = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/xbclean/MmReceiptReturn/list", params, token);
    };
    /*
     * 房间出入库表
     */
    GatewayClient.prototype.roomGoodInventoryList = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/xbclean/MmMonthlyRoomGoodsInventory/list", params, token);
    };
    /**
     * 根据领用归还表确认领用/归还
     * @param id 领用归还表id
     * @param updateName 	操作人
     */
    GatewayClient.prototype.affirmReceive = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/xbclean/MmReceiptReturn/affirmReceive", params, token);
    };
    /**
     * 根据领用归还单号查询商品集合（查看详情）
     * @param invoiceId 领用归还单号
     */
    GatewayClient.prototype.MmReceiptReturnGoods = function (invoiceId, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/xbclean/MmReceiptReturnGoods/list", invoiceId, token);
    };
    /**
     * 管家物资详情表
     * @param associatedNumber 	关联单号
     * @param associatedRepositoryName 关联中心仓
     * @param associatedRoomName 	关联房间
     * @param beginDate 	查询更新时间的开始
     * @param endDate 查询更新时间的结尾）
     * @param entryExitType 		出入库类型
     * @param goodsCatalog 	一级类目
     * @param goodsName 	商品名字
     * @param page 	页数
     * @param pageSize 	每页数据量
     * @param updateType 	更新类型
     * @param cleanerId 	管家id
     * @param goodsId 	物品id
     * @param updateStatus 	更新状态
     * @param associatedCityName 	关联城市名
     */
    GatewayClient.prototype.MmStewardGoodsInventoryParticular = function (params, token) {
        return this.prepareGetRequest(this
            .gatewayUrl + "api/oms/xbclean/MmStewardGoodsInventoryParticular/list", params, token);
    };
    /**
     * 管家物资月表
     * @param month 时间
     * @param cleanerAccount 管家手机
     * @param cleanerName 	管家名字
     * @param goodsName 		  商品名字
     * @param page 		        页数
     * @param pageSize 		   每页数据量
     * @param stockNumber 	 	 物料编号
     * @param associatedCityName 	 	 关联城市名
     */
    GatewayClient.prototype.MmMonthlyStewardGoodsInventory = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/xbclean/MmMonthlyStewardGoodsInventory/list", params, token);
    };
    /**
     * 获取管家月表所有管家
     */
    GatewayClient.prototype.MmMonthlygetCleanerList = function (params, token) {
        return this.prepareGetRequest(this
            .gatewayUrl + "api/oms/xbclean/MmMonthlyStewardGoodsInventory/getCleanerList", params, token);
    };
    /**
     *获取房间月表所有房间
     */
    GatewayClient.prototype.MmMonthlygetRoomList = function (params, token) {
        return this.prepareGetRequest(this
            .gatewayUrl + "api/oms/xbclean/MmMonthlyRoomGoodsInventory/getRoomList", params, token);
    };
    /**
     * 房间出入库明细表
     * @param endDate 截至时间
     * @param entryExitType 	出入库类型
     * @param goodsName 		  商品名字
     * @param page 		        页数
     * @param pageSize 		   每页数据量
     * @param stockNumber 	 	 物料编号
     * @param associatedCityName 	 	 关联城市名
     */
    GatewayClient.prototype.roomGoodInventoryDetailList = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/xbclean/MmRoomGoodsInventoryParticular/list", params, token);
    };
    /**
     * 获取房间易耗品和布草列表
     * @param cleanOrderId 清洁单Id
     * @param goodsAttribute 		物品属性
     * @param roomId 		  房间Id
     */
    GatewayClient.prototype.queryRoomGoodsList = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/xbclean/xbCleanOrder/roomGoodsList", params, token);
    };
    /**
     * 录入物品更换补充数据
     * @param cleanOrderId 清洁单Id
     * @param createName 		修改人
     * @param goodsId 		  物品Id
     * @param goodsName 		物品名称
     * @param num 		  数量
     * @param type 		  类型 3补充 4更换
     */
    GatewayClient.prototype.postAddDamageGoods = function (cleanOrderId, goodsDamageList, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/xbclean/xbCleanOrder/addDamageGoods", { cleanOrderId: cleanOrderId, goodsDamageList: goodsDamageList }, token);
    };
    /**
     * 销售单列表
     * @param beginDate 	起始时间
     * @param cleanOrderNo 		清洁单号
     * @param consumableSellState 	生成状态
     * @param endDate 		  终止时间
     * @param repositoryName 	中心仓名
     * @param consumableSellOrderNo 	单据编号
     * @param associatedCityName 	关联城市名
     */
    GatewayClient.prototype.sellListingList = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/xbclean/sellListing/list", params, token);
    };
    /**
    * 销售出库单的商品
    * @param consumableSellOrderId 	销售出库单id
    */
    GatewayClient.prototype.sellListingGoodsList = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/xbclean/sellListing/goodsList", params, token);
    };
    /**
    * 关联中心仓辐射城市
    * @param counties 	区县级集合
    * @param province 	省份名称
    * @param provinceId 	省份id
    * @param repositoryId 	中心仓id
    * @param createName
    */
    GatewayClient.prototype.postAddDistrict = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/admin/xbCenterRepository/addDistrict", params, token);
    };
    /**
    * 值班单列表
    * @param buildingAddress  值班地点
    * @param cleaner 	管家姓名/电话
    * @param contactPhone 	联系电话
    * @param createDateEnd 		创建日期止
    * @param createDateStart 	创建日期起
    * @param createName 	建单人
    * @param dutyDateEnd 	创建日期起
    * @param dutyDateStart 	值班日期止
    * @param dutyOrderNo  	值班单号
    * @param orderStatus 	订单进度
    * @param orderType 	单状态
    * @param page 	页数
    * @param search 	搜索值
    * @param size 		行数
    */
    GatewayClient.prototype.queryXbDutyOrderList = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/xbclean/xbDutyOrder/list", params, token);
    };
    /**
    * 创建值班单
    * @param buildingId  楼宇Id
    * @param cleanerId	 	管家Id
    * @param contactPhone 	联系电话
    * @param content 		工作内容
    * @param createName 		建单人
    * @param price 	薪酬(分)
    * @param serviceDate 	服务日期
    * @param serviceEndTime 	服务时间止
    * @param serviceStartTime 	服务时间起
    */
    GatewayClient.prototype.postXbDutyOrderAdd = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/oms/xbclean/xbDutyOrder/add", params, token);
    };
    /**
    * 取消值班单
    * @param dutyOrderId  值班单Id
    * @param updateName	 	操作人
    */
    GatewayClient.prototype.xbDutyOrderCancelOrder = function (params, token) {
        return this.preparePutRequest(this.gatewayUrl + "api/oms/xbclean/xbDutyOrder/cancelOrder", params, token);
    };
    /**
    * 指派值班单
    * @param cleanerId  管家Id
    * @param dutyOrderId	 	值班单Id
    * @param updateName	 	值班单Id
    */
    GatewayClient.prototype.xbDutyOrderAssignOrder = function (params, token) {
        return this.preparePutRequest(this.gatewayUrl + "api/oms/xbclean/xbDutyOrder/assignOrder", params, token);
    };
    /**
    * 查看值班单日志
    * @param dutyOrderId	 	值班单Id
    */
    GatewayClient.prototype.queryXbDutyOrderFindLog = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/xbclean/xbDutyOrder/findLog", params, token);
    };
    /**
    * 查看工作内容
    * @param dutyOrderId	 	值班单Id
    */
    GatewayClient.prototype.queryXbDutyOrderGetContent = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/xbclean/xbDutyOrder/getContent", params, token);
    };
    /**
    * 结束值班单
    * @param dutyOrderId	 	值班单Id
    * @param updateName	 	操作人
    */
    GatewayClient.prototype.xbDutyOrderOverDutyOrder = function (params, token) {
        return this.preparePutRequest(this.gatewayUrl + "api/oms/xbclean/xbDutyOrder/overDutyOrder", params, token);
    };
    /**
    * 获取楼宇权限列表
    */
    GatewayClient.prototype.queryXbDutyOrderGetBuildingList = function (token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/xbclean/xbDutyOrder/getBuildingList", {}, token);
    };
    /**
    * 获取楼宇权限列表
    * @params createDateEnd   创建日期止
    * @params createDateStart   创建日期起
    * @params page   页数
    * @params settlementDateEnd   结算日期止
    * @params settlementDateStart 结算日期起
    * @params size   行数
    * @params status   状态
    */
    GatewayClient.prototype.queryXbcleanXbDutyBillList = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/oms/xbclean/xbDutyBill/list", params, token);
    };
    ////////////////////////////// 艺龙接口 //////////////////////////////
    /**
     * queryElongOrderList
     * 获取查询艺龙订单列表
     * @params end_date	结束时间 string @mock=2018-11-11
     * @params mobile 手机号 string
     * @params name 名称 string
     * @params order_id 订单号 string
     * @params out_order_id 外部订单号--艺龙 string
     * @params page_num 当前页 string
     * @params page_size 页码 string
     * @params pay_status 支付状态，0-未支付，1--已支付,2--待退款，3--已退款，4--支付失败 number
     * @params start_date 开始时间 string
     * @params status 订单状态，0-待支付，1-待入住，2-已完成 3-已取消 number
     */
    GatewayClient.prototype.queryElongOrderList = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/v1/elong/oms/order-list", __assign({}, params), token);
    };
    /**
     * queryElongOrderList
     * 获取查询艺龙订单列表
     * @params end_date	结束时间 string @mock=2018-11-11
     * @params mobile 手机号 string
     * @params name 名称 string
     * @params order_id 订单号 string
     * @params out_order_id 外部订单号--艺龙 string
     * @params page_num 当前页 string
     * @params page_size 页码 string
     * @params pay_status 支付状态，0-未支付，1--已支付,2--待退款，3--已退款，4--支付失败 number
     * @params start_date 开始时间 string
     * @params status 订单状态，0-待支付，1-待入住，2-已完成 3-已取消 number
     */
    GatewayClient.prototype.exportList = function (params, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/v1/elong/oms/order-export", __assign({}, params), token);
    };
    /**
     * getElongOrderDetail 订单详情
     * @params orderId
     */
    GatewayClient.prototype.getElongOrderDetail = function (orderId, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/v1/elong/oms/order-detail/" + orderId, {}, token);
    };
    /**
     * orderContral 订单操作日志
     * @params orderId
     */
    GatewayClient.prototype.getElongOrderContral = function (orderId, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/v1/elong/oms/operation-list/" + orderId, {}, token);
    };
    /**
     * orderCancel 订单操作日志
     * @params operator_id 操作人（必填）string	@mock=1111
     * @params operator_name 操作人名称（必填）string @mock=测试
     * @params order_id	订单号（必填）	string	@mock=568213647564013568
     * @params reason	取消原因（必填）	string	@mock=test
     */
    GatewayClient.prototype.getElongOrderCancel = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/v1/elong/oms/order-cancel", __assign({}, params), token);
    };
    /**
     * queryTransactionList 获取查询交易列表
     * @params end_date	结束时间 string @mock=2018-11-11
     * @params order_id 号 string
     * @params out_order_id 外部订单号--艺龙 string
     * @params page_num 当前页 string
     * @params page_size 页码 string
     * @params pay_status 支付状态，0-未支付，1--已支付,2--待退款，3--已退款，4--支付失败 number
     * @params source_type 来源类型，微信：0；IOS：2；安卓：3；小程序：14  string
     * @params start_date 开始时间 string
     * @params trade_type 交易类型，1--支付，2--退款 string
     */
    GatewayClient.prototype.queryTransactionList = function (params, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/v1/elong/oms/trade-list", __assign({}, params), token);
    };
    /**
     * order-api
     * @param params
     * @param method
     * @param token
     */
    GatewayClient.prototype.orderApi = function (params, method, token) {
        if (method === void 0) { method = 'get'; }
        return this.prepareRequest(this.gatewayUrl + "api/order-api", params, method, token, params);
    };
    /**
     * 复制房间分页查询房间列表
     * @param param
     * @param token
     */
    GatewayClient.prototype.getRoomlist = function (param, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/roomInfo/search/withoutBuilding", param, token);
    };
    /**
     * 复制房间分页查询其他房间列表
     * @param param
     * @param token
     */
    GatewayClient.prototype.getOtherRoomlist = function (param, token) {
        return this.prepareGetRequest(this.gatewayUrl + "api/roomInfo/copyPicture/searchOtherRooms/all", param, token);
    };
    /**
     * 复制图片 - 复制到指定房间
     */
    GatewayClient.prototype.copyImgToRoom = function (param, token) {
        return this.preparePostRequest(this.gatewayUrl + "api/roomInfo/copyPicture/toRooms", param, token);
    };
    /**
     * 批量更改房间预售状态
     */
    GatewayClient.prototype.updatePresaleBatname = function (param, token) {
        return this.prepareRequest(this.gatewayUrl + "api/roomInfo/updateIsPresaleBatch", {}, 'put', token, param);
    };
    /**
     * roomSystem
     * @param params
     * @param method
     * @param token
     */
    GatewayClient.prototype.roomSystem = function (params, method, token, data) {
        if (method === void 0) { method = 'get'; }
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.gatewayUrl + "api/roomSystem-api", data, method, token, params);
    };
    /**
     * roomApi
     * @param params
     * @param method
     * @param token
     */
    GatewayClient.prototype.roomApi = function (params, method, token, data) {
        if (method === void 0) { method = 'get'; }
        if (data === void 0) { data = {}; }
        return this.prepareRequest(this.gatewayUrl + "api/room-api", data, method, token, params);
    };
    ////////////////////////////// Private //////////////////////////////
    /////////////////////////////////////////////////////////////////////
    /**
     * 请求gateway前的封装
     * @param url
     * @param reqData
     * @param method
     * @param token
     * @param header
     */
    GatewayClient.prototype.prepareRequest = function (url, reqData, method, token, params, header) {
        if (token === void 0) { token = ''; }
        /**
         * 如果是get 和 put，用url params生成Sign，如果是post则用reqData生成Sign
         * @param httpMethod Http 请求方法
         */
        var signWithReqData = function (httpMethod) {
            if (httpMethod === 'get' || httpMethod === 'put') {
                return false;
            }
            return true;
        };
        if (!header) {
            header = {
                Edition: this.edition,
                Goods: this.goods,
                Terrace: this.terrace
            };
        }
        // 生成secretKey
        var secretKey = this.secret.getGatewayAPISecretKey(header.Goods, header.Terrace, header.Edition, token);
        header.Pencil = this.secret.getSign(signWithReqData(method) ? reqData : params, secretKey);
        header.secret = secretKey;
        header.Right = token;
        return this.fetch(url, header, method, reqData, true, params);
    };
    GatewayClient.prototype.preparePostRequest = function (url, reqData, token) {
        if (token === void 0) { token = ''; }
        return this.prepareRequest(url, reqData, 'post', token);
    };
    GatewayClient.prototype.prepareGetRequest = function (url, params, token, header) {
        return this.prepareRequest(url, params, 'get', token, params, header);
    };
    GatewayClient.prototype.preparePutRequest = function (url, params, token, header) {
        return this.prepareRequest(url, params, 'put', token, params, header);
    };
    return GatewayClient;
}(base_1.BaseClient));
exports.GatewayClient = GatewayClient;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./node_modules/xbed-api/lib/clients/gateway-client.js
// module id = 199
// module chunks = 44